import React from "react";

export const Dashboard = (color) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3358_5344)">
        <path
          d="M6.3958 1H2.0208C1.4579 1 1 1.4579 1 2.0208V4.6458C1 5.2088 1.4579 5.6667 2.0208 5.6667H6.3958C6.9588 5.6667 7.4167 5.2088 7.4167 4.6458V2.0208C7.4167 1.4579 6.9588 1 6.3958 1Z"
          fill="#1B3048"
          fillOpacity="1"
        />
        <path
          d="M6.3958 6.83398H2.0208C1.4579 6.83398 1 7.29189 1 7.85489V13.9799C1 14.5428 1.4579 15.0007 2.0208 15.0007H6.3958C6.9588 15.0007 7.4167 14.5428 7.4167 13.9799V7.85489C7.4167 7.29189 6.9588 6.83398 6.3958 6.83398Z"
          fill="#1B3048"
          fillOpacity="1"
        />
        <path
          d="M13.9799 10.334H9.60489C9.04189 10.334 8.58398 10.7919 8.58398 11.3549V13.9799C8.58398 14.5428 9.04189 15.0007 9.60489 15.0007H13.9799C14.5428 15.0007 15.0007 14.5428 15.0007 13.9799V11.3549C15.0007 10.7919 14.5428 10.334 13.9799 10.334Z"
          fill="#1B3048"
          fillOpacity="1"
        />
        <path
          d="M13.9799 1H9.60489C9.04189 1 8.58398 1.4579 8.58398 2.0208V8.1458C8.58398 8.7088 9.04189 9.1667 9.60489 9.1667H13.9799C14.5428 9.1667 15.0007 8.7088 15.0007 8.1458V2.0208C15.0007 1.4579 14.5428 1 13.9799 1Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3358_5344">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WebSite = (color) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8413)">
        <path
          d="M15 4.30859V2.25781C15 1.57933 14.448 1.02734 13.7695 1.02734H2.23047C1.55199 1.02734 1 1.57933 1 2.25781V4.30859H15ZM10.4609 2.66797H12.9219C13.1484 2.66797 13.332 2.85161 13.332 3.07812C13.332 3.30464 13.1484 3.48828 12.9219 3.48828H10.4609C10.2344 3.48828 10.0508 3.30464 10.0508 3.07812C10.0508 2.85161 10.2344 2.66797 10.4609 2.66797ZM6.35938 2.66797C6.58589 2.66797 6.76953 2.85161 6.76953 3.07812C6.76953 3.30464 6.58589 3.48828 6.35938 3.48828C6.13286 3.48828 5.94922 3.30464 5.94922 3.07812C5.94922 2.85161 6.13286 2.66797 6.35938 2.66797ZM4.71875 2.66797C4.94527 2.66797 5.12891 2.85161 5.12891 3.07812C5.12891 3.30464 4.94527 3.48828 4.71875 3.48828C4.49223 3.48828 4.30859 3.30464 4.30859 3.07812C4.30859 2.85161 4.49223 2.66797 4.71875 2.66797ZM3.07812 2.66797C3.30464 2.66797 3.48828 2.85161 3.48828 3.07812C3.48828 3.30464 3.30464 3.48828 3.07812 3.48828C2.85161 3.48828 2.66797 3.30464 2.66797 3.07812C2.66797 2.85161 2.85161 2.66797 3.07812 2.66797Z"
          fill="#1B3048"
          fillOpacity="1"
        />
        <path
          d="M1 5.12891V13.7422C1 14.4207 1.55199 14.9727 2.23047 14.9727H13.7695C14.448 14.9727 15 14.4207 15 13.7422V5.12891H1ZM5.79527 10.961C5.97219 11.1025 6.00084 11.3606 5.85934 11.5375C5.71786 11.7143 5.45971 11.743 5.28285 11.6015L3.23207 9.96088C3.02702 9.79689 3.02688 9.48444 3.23207 9.32032L5.28285 7.6797C5.45966 7.53819 5.71781 7.56685 5.85934 7.74373C6.00084 7.92062 5.97219 8.17875 5.79527 8.32022L4.14486 9.64062L5.79527 10.961ZM9.60746 6.93111L7.14652 12.6733C7.0573 12.8815 6.81623 12.978 6.60796 12.8887C6.39976 12.7995 6.30329 12.5583 6.39254 12.3501L8.85348 6.60796C8.94273 6.39976 9.18385 6.30332 9.39204 6.39254C9.60024 6.48177 9.69671 6.72288 9.60746 6.93111ZM12.7679 9.9609L10.7171 11.6015C10.5406 11.7428 10.2824 11.7146 10.1407 11.5375C9.99916 11.3606 10.0278 11.1025 10.2047 10.961L11.8551 9.64062L10.2047 8.32028C10.0278 8.17877 9.99916 7.92068 10.1407 7.74379C10.2821 7.5669 10.5403 7.53822 10.7171 7.67975L12.7679 9.32037C12.973 9.48436 12.9731 9.79679 12.7679 9.9609Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_8413">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Products = (color) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_3304_8447)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.46667 12.2698L1.06667 9.0285V12.4248C1.06667 12.6296 1.1808 12.8165 1.3616 12.9078L7.46667 16V12.2698ZM8.53333 12.2698V16L14.6384 12.9078C14.8192 12.8165 14.9333 12.6296 14.9333 12.4248V9.0285L8.53333 12.2698ZM7.46667 8.43697L0.00213331 4.65653L0 7.02214C0 7.22688 0.114133 7.41434 0.294933 7.50563L7.46667 11.1381V8.43697ZM15.9979 4.65653L8.53333 8.43697V11.1381L15.7051 7.50563C15.8859 7.41434 16 7.22688 16 7.02214L15.9979 4.65653ZM0.533333 3.71764L8 7.49915L15.4667 3.71764L8.2384 0.0571279C8.08853 -0.0190426 7.91147 -0.0190426 7.7616 0.0571279L0.533333 3.71764Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_8447">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ProductListIcon1 = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
      <path d="M6.85714 0H0V7.53203H6.85714V0Z" fill="#111827" />
      <path d="M15.9997 0H9.14258V7.53203H15.9997V0Z" fill="#111827" />
      <path d="M6.85714 10.042H0V17.574H6.85714V10.042Z" fill="#111827" />
      <path d="M15.9997 10.042H9.14258V17.574H15.9997V10.042Z" fill="#111827" />
    </svg>
  )
}

export const ProductListIcon2 = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M1.8 3.95432C2.79411 3.95432 3.6 3.06911 3.6 1.97716C3.6 0.885204 2.79411 0 1.8 0C0.805887 0 0 0.885204 0 1.97716C0 3.06911 0.805887 3.95432 1.8 3.95432Z" fill="#1D3148" fillOpacity="0.5" />
      <path d="M7.20039 3.95432H16.2004C17.1904 3.95432 18.0004 3.0646 18.0004 1.97716C18.0004 0.889721 17.1904 0 16.2004 0H7.20039C6.21039 0 5.40039 0.889721 5.40039 1.97716C5.40039 3.0646 6.21039 3.95432 7.20039 3.95432Z" fill="#1D3148" fillOpacity="0.5" />
      <path d="M1.8 10.8742C2.79411 10.8742 3.6 9.98904 3.6 8.89708C3.6 7.80513 2.79411 6.91992 1.8 6.91992C0.805887 6.91992 0 7.80513 0 8.89708C0 9.98904 0.805887 10.8742 1.8 10.8742Z" fill="#1D3148" fillOpacity="0.5" />
      <path d="M16.2004 6.91992H7.20039C6.21039 6.91992 5.40039 7.80964 5.40039 8.89708C5.40039 9.98452 6.21039 10.8742 7.20039 10.8742H16.2004C17.1904 10.8742 18.0004 9.98452 18.0004 8.89708C18.0004 7.80964 17.1904 6.91992 16.2004 6.91992Z" fill="#1D3148" fillOpacity="0.5" />
      <path d="M1.8 17.7942C2.79411 17.7942 3.6 16.909 3.6 15.817C3.6 14.725 2.79411 13.8398 1.8 13.8398C0.805887 13.8398 0 14.725 0 15.817C0 16.909 0.805887 17.7942 1.8 17.7942Z" fill="#1D3148" fillOpacity="0.5" />
      <path d="M16.2004 13.8398H7.20039C6.21039 13.8398 5.40039 14.7296 5.40039 15.817C5.40039 16.9044 6.21039 17.7942 7.20039 17.7942H16.2004C17.1904 17.7942 18.0004 16.9044 18.0004 15.817C18.0004 14.7296 17.1904 13.8398 16.2004 13.8398Z" fill="#1D3148" fillOpacity="0.5" />
    </svg>
  )
}

export const Filters = (color) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.22534 4.77967C7.49268 4.77967 7.76002 4.77967 8.02735 4.77967C8.66285 4.77967 9.29987 4.77967 9.93537 4.77967C10.7038 4.77967 11.4737 4.77967 12.2421 4.77967C12.9112 4.77967 13.5803 4.77967 14.2494 4.77967C14.5717 4.77967 14.8956 4.78426 15.2179 4.77967C15.2225 4.77967 15.2271 4.77967 15.2317 4.77967C15.4272 4.77967 15.6335 4.69413 15.7725 4.55664C15.9054 4.42373 16.0047 4.20681 15.9955 4.01586C15.9863 3.81879 15.9222 3.61409 15.7725 3.47507C15.6228 3.33758 15.4394 3.25204 15.2317 3.25204C14.9644 3.25204 14.697 3.25204 14.4297 3.25204C13.7942 3.25204 13.1572 3.25204 12.5217 3.25204C11.7533 3.25204 10.9833 3.25204 10.2149 3.25204C9.54582 3.25204 8.87672 3.25204 8.20761 3.25204C7.88528 3.25204 7.56142 3.24745 7.23909 3.25204C7.23451 3.25204 7.22993 3.25204 7.22534 3.25204C7.02981 3.25204 6.82357 3.33758 6.68456 3.47507C6.55165 3.60798 6.45236 3.8249 6.46152 4.01586C6.47069 4.21292 6.53485 4.41762 6.68456 4.55664C6.83427 4.6926 7.01911 4.77967 7.22534 4.77967Z"
        fill="#111827"
      />
      <path
        d="M2.76441 4.77959C3.31741 4.77959 3.87041 4.77959 4.42342 4.77959C4.50133 4.77959 4.58077 4.77959 4.65868 4.77959C4.85421 4.77959 5.06044 4.69404 5.19946 4.55656C5.33236 4.42365 5.43166 4.20673 5.42249 4.01577C5.41333 3.81871 5.34917 3.614 5.19946 3.47499C5.04975 3.3375 4.86643 3.25195 4.65868 3.25195C4.10567 3.25195 3.55267 3.25195 2.99966 3.25195C2.92175 3.25195 2.84231 3.25195 2.76441 3.25195C2.56887 3.25195 2.36264 3.3375 2.22362 3.47499C2.09072 3.60789 1.99142 3.82482 2.00059 4.01577C2.00975 4.21284 2.07391 4.41754 2.22362 4.55656C2.37333 4.69252 2.55817 4.77959 2.76441 4.77959Z"
        fill="#111827"
      />
      <path
        d="M5.94367 4.53925C5.88715 4.53925 5.83062 4.53466 5.7741 4.52855C5.84132 4.53772 5.91006 4.54688 5.97728 4.55605C5.86118 4.53925 5.74966 4.50869 5.6412 4.46439C5.7023 4.49036 5.76341 4.51633 5.82298 4.54077C5.72369 4.498 5.63203 4.443 5.54648 4.37884C5.59842 4.41856 5.64883 4.45828 5.70077 4.498C5.61064 4.42773 5.53121 4.34829 5.46093 4.25816C5.50065 4.3101 5.54037 4.36051 5.58009 4.41245C5.5144 4.3269 5.46093 4.23372 5.41816 4.13595C5.44413 4.19705 5.4701 4.25816 5.49454 4.31774C5.44871 4.20928 5.41816 4.09776 5.40288 3.98166C5.41205 4.04887 5.42122 4.11762 5.43038 4.18483C5.41663 4.07179 5.41663 3.95874 5.43038 3.8457C5.42122 3.91291 5.41205 3.98166 5.40288 4.04887C5.41969 3.93277 5.45024 3.82126 5.49454 3.71279C5.46857 3.7739 5.4426 3.835 5.41816 3.89458C5.46093 3.79529 5.51593 3.70363 5.58009 3.61808C5.54037 3.67002 5.50065 3.72043 5.46093 3.77237C5.53121 3.68224 5.61064 3.6028 5.70077 3.53253C5.64883 3.57225 5.59842 3.61197 5.54648 3.65169C5.63203 3.586 5.72522 3.53253 5.82298 3.48976C5.76188 3.51573 5.70077 3.5417 5.6412 3.56614C5.74966 3.52031 5.86118 3.48976 5.97728 3.47448C5.91006 3.48365 5.84132 3.49281 5.7741 3.50198C5.88715 3.48823 6.00019 3.48823 6.11324 3.50198C6.04602 3.49281 5.97728 3.48365 5.91006 3.47448C6.02616 3.49129 6.13768 3.52184 6.24614 3.56614C6.18503 3.54017 6.12393 3.5142 6.06435 3.48976C6.16365 3.53253 6.25531 3.58753 6.34085 3.65169C6.28891 3.61197 6.2385 3.57225 6.18656 3.53253C6.27669 3.6028 6.35613 3.68224 6.4264 3.77237C6.38668 3.72043 6.34696 3.67002 6.30725 3.61808C6.37293 3.70363 6.4264 3.79681 6.46918 3.89458C6.44321 3.83348 6.41724 3.77237 6.39279 3.71279C6.43862 3.82126 6.46918 3.93277 6.48445 4.04887C6.47529 3.98166 6.46612 3.91291 6.45695 3.8457C6.4707 3.95874 6.4707 4.07179 6.45695 4.18483C6.46612 4.11762 6.47529 4.04887 6.48445 3.98166C6.46765 4.09776 6.4371 4.20928 6.39279 4.31774C6.41876 4.25663 6.44473 4.19553 6.46918 4.13595C6.4264 4.23525 6.37141 4.3269 6.30725 4.41245C6.34696 4.36051 6.38668 4.3101 6.4264 4.25816C6.35613 4.34829 6.27669 4.42773 6.18656 4.498C6.2385 4.45828 6.28891 4.41856 6.34085 4.37884C6.25531 4.44453 6.16212 4.498 6.06435 4.54077C6.12546 4.5148 6.18656 4.48883 6.24614 4.46439C6.13768 4.51022 6.02616 4.54077 5.91006 4.55605C5.97728 4.54688 6.04602 4.53772 6.11324 4.52855C6.05671 4.53466 6.00019 4.53925 5.94367 4.53925C5.7466 4.54077 5.54343 4.62327 5.40288 4.76228C5.26998 4.89518 5.17068 5.11211 5.17985 5.30306C5.18902 5.50013 5.25318 5.70483 5.40288 5.84385C5.55107 5.97981 5.73591 6.06994 5.94367 6.06688C6.14837 6.06535 6.36377 6.03786 6.55778 5.97217C6.73804 5.91106 6.92441 5.83315 7.08023 5.72011C7.18105 5.64831 7.28341 5.57193 7.37354 5.48638C7.46825 5.39625 7.54769 5.28779 7.6256 5.18391C7.7417 5.02656 7.81961 4.85088 7.88682 4.66757C8.02584 4.2933 8.02737 3.84264 7.9189 3.45921C7.86544 3.26825 7.78294 3.07577 7.67143 2.91078C7.56755 2.75497 7.44534 2.59762 7.29868 2.47694C7.20244 2.3975 7.10315 2.31806 6.99774 2.2539C6.88622 2.18668 6.76401 2.1378 6.64485 2.09044C6.45543 2.01406 6.25531 1.98504 6.05213 1.96823C5.658 1.93615 5.22873 2.05072 4.89265 2.2539C4.56574 2.45249 4.26938 2.75344 4.10898 3.10479C4.05704 3.21937 4.00357 3.337 3.96996 3.45921C3.93483 3.58447 3.92108 3.71585 3.90427 3.8457C3.87983 4.05346 3.90427 4.2658 3.94552 4.4705C4.02648 4.87533 4.27091 5.29237 4.59018 5.5536C4.69101 5.63609 4.79641 5.72011 4.90946 5.78732C5.02709 5.85607 5.15694 5.90801 5.28373 5.95536C5.49149 6.0348 5.72522 6.06535 5.9452 6.06688C6.14073 6.06841 6.34849 5.97981 6.48598 5.84385C6.61888 5.71094 6.71818 5.49402 6.70901 5.30306C6.68916 4.88602 6.37141 4.5423 5.94367 4.53925Z"
        fill="#111827"
      />
      <path
        d="M13.1863 10.0042C13.7851 10.0042 14.3839 10.0042 14.9813 10.0042C15.0653 10.0042 15.1493 10.0042 15.2333 10.0042C15.4289 10.0042 15.6351 9.91865 15.7741 9.78116C15.907 9.64826 16.0063 9.43134 15.9971 9.24038C15.988 9.04332 15.9238 8.83861 15.7741 8.6996C15.6244 8.56211 15.4411 8.47656 15.2333 8.47656C14.6345 8.47656 14.0356 8.47656 13.4383 8.47656C13.3543 8.47656 13.2703 8.47656 13.1863 8.47656C12.9907 8.47656 12.7845 8.56211 12.6455 8.6996C12.5126 8.8325 12.4133 9.04943 12.4225 9.24038C12.4316 9.43745 12.4958 9.64215 12.6455 9.78116C12.7952 9.91712 12.98 10.0042 13.1863 10.0042Z"
        fill="#111827"
      />
      <path
        d="M2.76441 10.0062C3.02563 10.0062 3.28838 10.0062 3.54961 10.0062C4.17289 10.0062 4.79616 10.0062 5.41944 10.0062C6.17562 10.0062 6.9318 10.0062 7.68798 10.0062C8.34181 10.0062 8.99564 10.0062 9.64947 10.0062C9.96722 10.0062 10.285 10.0108 10.6027 10.0062C10.6073 10.0062 10.6119 10.0062 10.6165 10.0062C10.812 10.0062 11.0182 9.92069 11.1572 9.7832C11.2901 9.6503 11.3894 9.43337 11.3803 9.24242C11.3711 9.04535 11.307 8.84065 11.1572 8.70163C11.0075 8.56415 10.8242 8.4786 10.6165 8.4786C10.3552 8.4786 10.0925 8.4786 9.83125 8.4786C9.20798 8.4786 8.5847 8.4786 7.96143 8.4786C7.20525 8.4786 6.44907 8.4786 5.69289 8.4786C5.03906 8.4786 4.38523 8.4786 3.7314 8.4786C3.41365 8.4786 3.0959 8.47402 2.77815 8.4786C2.77357 8.4786 2.76899 8.4786 2.76441 8.4786C2.56887 8.4786 2.36264 8.56415 2.22362 8.70163C2.09072 8.83454 1.99142 9.05146 2.00059 9.24242C2.00975 9.43948 2.07391 9.64419 2.22362 9.7832C2.37333 9.91916 2.55817 10.0062 2.76441 10.0062Z"
        fill="#111827"
      />
      <path
        d="M11.8944 9.7619C11.8379 9.7619 11.7814 9.75732 11.7248 9.75121C11.7921 9.76037 11.8608 9.76954 11.928 9.77871C11.8119 9.7619 11.7004 9.73135 11.5919 9.68705C11.653 9.71302 11.7142 9.73899 11.7737 9.76343C11.6744 9.72066 11.5828 9.66566 11.4972 9.6015C11.5492 9.64122 11.5996 9.68094 11.6515 9.72066C11.5614 9.65038 11.482 9.57095 11.4117 9.48082C11.4514 9.53276 11.4911 9.58317 11.5308 9.63511C11.4651 9.54956 11.4117 9.45637 11.3689 9.35861C11.3949 9.41971 11.4208 9.48082 11.4453 9.54039C11.3995 9.43193 11.3689 9.32041 11.3536 9.20431C11.3628 9.27153 11.372 9.34027 11.3811 9.40749C11.3674 9.29444 11.3674 9.1814 11.3811 9.06835C11.372 9.13557 11.3628 9.20431 11.3536 9.27153C11.3704 9.15543 11.401 9.04391 11.4453 8.93545C11.4193 8.99656 11.3933 9.05766 11.3689 9.11724C11.4117 9.01794 11.4667 8.92628 11.5308 8.84074C11.4911 8.89268 11.4514 8.94309 11.4117 8.99503C11.482 8.9049 11.5614 8.82546 11.6515 8.75519C11.5996 8.79491 11.5492 8.83463 11.4972 8.87434C11.5828 8.80866 11.676 8.75519 11.7737 8.71242C11.7126 8.73838 11.6515 8.76435 11.5919 8.7888C11.7004 8.74297 11.8119 8.71242 11.928 8.69714C11.8608 8.7063 11.7921 8.71547 11.7248 8.72464C11.8379 8.71089 11.9509 8.71089 12.064 8.72464C11.9968 8.71547 11.928 8.7063 11.8608 8.69714C11.9769 8.71394 12.0884 8.7445 12.1969 8.7888C12.1358 8.76283 12.0747 8.73686 12.0151 8.71242C12.1144 8.75519 12.2061 8.81018 12.2916 8.87434C12.2397 8.83463 12.1892 8.79491 12.1373 8.75519C12.2274 8.82546 12.3069 8.9049 12.3771 8.99503C12.3374 8.94309 12.2977 8.89268 12.258 8.84074C12.3237 8.92628 12.3771 9.01947 12.4199 9.11724C12.394 9.05613 12.368 8.99503 12.3435 8.93545C12.3894 9.04391 12.4199 9.15543 12.4352 9.27153C12.426 9.20431 12.4169 9.13557 12.4077 9.06835C12.4214 9.1814 12.4214 9.29444 12.4077 9.40749C12.4169 9.34027 12.426 9.27153 12.4352 9.20431C12.4184 9.32041 12.3878 9.43193 12.3435 9.54039C12.3695 9.47929 12.3955 9.41818 12.4199 9.35861C12.3771 9.4579 12.3222 9.54956 12.258 9.63511C12.2977 9.58317 12.3374 9.53276 12.3771 9.48082C12.3069 9.57095 12.2274 9.65038 12.1373 9.72066C12.1892 9.68094 12.2397 9.64122 12.2916 9.6015C12.2061 9.66719 12.1129 9.72066 12.0151 9.76343C12.0762 9.73746 12.1373 9.71149 12.1969 9.68705C12.0884 9.73288 11.9769 9.76343 11.8608 9.77871C11.928 9.76954 11.9968 9.76037 12.064 9.75121C12.0075 9.75732 11.9509 9.7619 11.8944 9.7619C11.6973 9.76343 11.4942 9.84592 11.3536 9.98494C11.2207 10.1178 11.1214 10.3348 11.1306 10.5257C11.1398 10.7228 11.2039 10.9275 11.3536 11.0665C11.5018 11.2025 11.6867 11.2926 11.8944 11.2895C12.0991 11.288 12.3145 11.2605 12.5085 11.1948C12.6888 11.1337 12.8752 11.0558 13.031 10.9428C13.1318 10.871 13.2342 10.7946 13.3243 10.709C13.419 10.6189 13.4984 10.5104 13.5763 10.4066C13.6924 10.2492 13.7704 10.0735 13.8376 9.89022C13.9766 9.51595 13.9781 9.0653 13.8696 8.68186C13.8162 8.49091 13.7337 8.29843 13.6222 8.13344C13.5168 7.97609 13.3946 7.82027 13.2479 7.69959C13.1517 7.62015 13.0524 7.54072 12.947 7.47656C12.8354 7.40934 12.7132 7.36046 12.5941 7.3131C12.4046 7.23672 12.2045 7.20769 12.0013 7.19089C11.6072 7.15881 11.178 7.27338 10.8419 7.47656C10.515 7.67515 10.2186 7.97609 10.0582 8.32745C10.0063 8.44202 9.95279 8.55965 9.91918 8.68186C9.88404 8.80713 9.8703 8.93851 9.85349 9.06835C9.82905 9.27611 9.85349 9.48845 9.89474 9.69316C9.9757 10.098 10.2201 10.515 10.5394 10.7763C10.6402 10.8587 10.7456 10.9428 10.8587 11.01C10.9763 11.0787 11.1062 11.1307 11.2329 11.178C11.4407 11.2575 11.6744 11.288 11.8944 11.2895C12.09 11.2911 12.2977 11.2025 12.4352 11.0665C12.5681 10.9336 12.6674 10.7167 12.6582 10.5257C12.6399 10.1087 12.3222 9.76496 11.8944 9.7619Z"
        fill="#111827"
      />
      <path
        d="M9.67066 15.2282C9.85397 15.2282 10.0388 15.2282 10.2221 15.2282C10.6636 15.2282 11.1066 15.2282 11.5481 15.2282C12.0828 15.2282 12.619 15.2282 13.1537 15.2282C13.6165 15.2282 14.0794 15.2282 14.5423 15.2282C14.7684 15.2282 14.9945 15.2313 15.2206 15.2282C15.2236 15.2282 15.2267 15.2282 15.2313 15.2282C15.4268 15.2282 15.633 15.1427 15.772 15.0052C15.9049 14.8723 16.0042 14.6553 15.9951 14.4644C15.9859 14.2673 15.9217 14.0626 15.772 13.9236C15.6223 13.7861 15.439 13.7006 15.2313 13.7006C15.0479 13.7006 14.8631 13.7006 14.6798 13.7006C14.2383 13.7006 13.7953 13.7006 13.3538 13.7006C12.8191 13.7006 12.2829 13.7006 11.7482 13.7006C11.2854 13.7006 10.8225 13.7006 10.3596 13.7006C10.1335 13.7006 9.90744 13.6975 9.68135 13.7006C9.67829 13.7006 9.67524 13.7006 9.67066 13.7006C9.47512 13.7006 9.26889 13.7861 9.12987 13.9236C8.99697 14.0565 8.89767 14.2734 8.90684 14.4644C8.916 14.6615 8.98016 14.8662 9.12987 15.0052C9.27958 15.1411 9.46442 15.2282 9.67066 15.2282Z"
        fill="#111827"
      />
      <path
        d="M2.76441 15.2288C3.25172 15.2288 3.73904 15.2288 4.22788 15.2288C5.0085 15.2288 5.7876 15.2288 6.56822 15.2288C6.74696 15.2288 6.92569 15.2288 7.1029 15.2288C7.29843 15.2288 7.50466 15.1433 7.64368 15.0058C7.77658 14.8729 7.87588 14.6559 7.86671 14.465C7.85755 14.2679 7.79339 14.0632 7.64368 13.9242C7.49397 13.7867 7.31065 13.7012 7.1029 13.7012C6.61558 13.7012 6.12826 13.7012 5.63942 13.7012C4.8588 13.7012 4.0797 13.7012 3.29908 13.7012C3.12034 13.7012 2.94161 13.7012 2.76441 13.7012C2.56887 13.7012 2.36264 13.7867 2.22362 13.9242C2.09072 14.0571 1.99142 14.274 2.00059 14.465C2.00975 14.6621 2.07391 14.8668 2.22362 15.0058C2.37333 15.1417 2.55817 15.2288 2.76441 15.2288Z"
        fill="#111827"
      />
      <path
        d="M8.3866 14.9865C8.33008 14.9865 8.27356 14.9819 8.21703 14.9758C8.28425 14.985 8.35299 14.9941 8.42021 15.0033C8.30411 14.9865 8.19259 14.956 8.08413 14.9117C8.14524 14.9376 8.20634 14.9636 8.26592 14.988C8.16662 14.9453 8.07496 14.8903 7.98942 14.8261C8.04136 14.8658 8.09177 14.9055 8.14371 14.9453C8.05358 14.875 7.97414 14.7956 7.90387 14.7054C7.94359 14.7574 7.98331 14.8078 8.02302 14.8597C7.95734 14.7742 7.90387 14.681 7.86109 14.5832C7.88706 14.6443 7.91303 14.7054 7.93748 14.765C7.89165 14.6565 7.86109 14.545 7.84582 14.4289C7.85498 14.4961 7.86415 14.5649 7.87332 14.6321C7.85957 14.5191 7.85957 14.406 7.87332 14.293C7.86415 14.3602 7.85498 14.4289 7.84582 14.4961C7.86262 14.38 7.89317 14.2685 7.93748 14.1601C7.91151 14.2212 7.88554 14.2823 7.86109 14.3418C7.90387 14.2426 7.95886 14.1509 8.02302 14.0653C7.98331 14.1173 7.94359 14.1677 7.90387 14.2196C7.97414 14.1295 8.05358 14.0501 8.14371 13.9798C8.09177 14.0195 8.04136 14.0592 7.98942 14.099C8.07496 14.0333 8.16815 13.9798 8.26592 13.937C8.20481 13.963 8.14371 13.989 8.08413 14.0134C8.19259 13.9676 8.30411 13.937 8.42021 13.9217C8.35299 13.9309 8.28425 13.9401 8.21703 13.9492C8.33008 13.9355 8.44312 13.9355 8.55617 13.9492C8.48895 13.9401 8.42021 13.9309 8.35299 13.9217C8.46909 13.9386 8.58061 13.9691 8.68907 14.0134C8.62797 13.9874 8.56686 13.9615 8.50729 13.937C8.60658 13.9798 8.69824 14.0348 8.78379 14.099C8.73185 14.0592 8.68144 14.0195 8.6295 13.9798C8.71963 14.0501 8.79906 14.1295 8.86933 14.2196C8.82962 14.1677 8.7899 14.1173 8.75018 14.0653C8.81587 14.1509 8.86934 14.2441 8.91211 14.3418C8.88614 14.2807 8.86017 14.2196 8.83573 14.1601C8.88156 14.2685 8.91211 14.38 8.92739 14.4961C8.91822 14.4289 8.90905 14.3602 8.89989 14.293C8.91364 14.406 8.91364 14.5191 8.89989 14.6321C8.90905 14.5649 8.91822 14.4961 8.92739 14.4289C8.91058 14.545 8.88003 14.6565 8.83573 14.765C8.8617 14.7039 8.88767 14.6428 8.91211 14.5832C8.86934 14.6825 8.81434 14.7742 8.75018 14.8597C8.7899 14.8078 8.82962 14.7574 8.86933 14.7054C8.79906 14.7956 8.71963 14.875 8.6295 14.9453C8.68144 14.9055 8.73185 14.8658 8.78379 14.8261C8.69824 14.8918 8.60505 14.9453 8.50729 14.988C8.56839 14.9621 8.6295 14.9361 8.68907 14.9117C8.58061 14.9575 8.46909 14.988 8.35299 15.0033C8.42021 14.9941 8.48895 14.985 8.55617 14.9758C8.49965 14.9819 8.44312 14.9865 8.3866 14.9865C8.18954 14.988 7.98636 15.0705 7.84582 15.2095C7.71291 15.3425 7.61362 15.5594 7.62278 15.7503C7.63195 15.9474 7.69611 16.1521 7.84582 16.2911C7.994 16.4271 8.17884 16.5172 8.3866 16.5141C8.59131 16.5126 8.8067 16.4851 9.00071 16.4194C9.18097 16.3583 9.36734 16.2804 9.52316 16.1674C9.62399 16.0956 9.72634 16.0192 9.81647 15.9336C9.91118 15.8435 9.99062 15.7351 10.0685 15.6312C10.1846 15.4738 10.2625 15.2981 10.3298 15.1148C10.4688 14.7406 10.4703 14.2899 10.3618 13.9065C10.3084 13.7155 10.2259 13.523 10.1144 13.3581C10.009 13.2007 9.88674 13.0449 9.74009 12.9242C9.64385 12.8448 9.54455 12.7653 9.43914 12.7012C9.32763 12.634 9.20542 12.5851 9.08626 12.5377C8.89683 12.4613 8.69671 12.4323 8.49354 12.4155C8.09941 12.3834 7.67014 12.498 7.33406 12.7012C7.00715 12.8998 6.71078 13.2007 6.55038 13.5521C6.49844 13.6666 6.44498 13.7843 6.41137 13.9065C6.37623 14.0317 6.36248 14.1631 6.34568 14.293C6.32124 14.5007 6.34568 14.7131 6.38692 14.9178C6.46789 15.3226 6.71231 15.7396 7.03159 16.0009C7.13241 16.0834 7.23782 16.1674 7.35086 16.2346C7.46849 16.3033 7.59834 16.3553 7.72513 16.4026C7.93289 16.4821 8.16662 16.5126 8.3866 16.5141C8.58214 16.5157 8.7899 16.4271 8.92739 16.2911C9.06029 16.1582 9.15959 15.9413 9.15042 15.7503C9.13209 15.3333 8.81434 14.9896 8.3866 14.9865Z"
        fill="#111827"
      />
    </svg>
  );
};
export const Options = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 48 60" fill="black" width="18"
      height="18">
      <path d="M25.5,16c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5S25.5,15.2,25.5,16z M24,22.5  c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S24.8,22.5,24,22.5z M24,30.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5  s1.5-0.7,1.5-1.5S24.8,30.5,24,30.5z" /></svg>
  )
}

export const ProductListDownload = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M3 12.1661V15.4994C3.00003 15.7612 3.23821 15.9994 3.5 15.9994H14.5C14.7618 15.9994 15 15.7612 15 15.4994V12.1661C15 11.9043 14.7618 11.6661 14.5 11.6661H13.6667C13.4025 11.6624 13.1595 11.9019 13.1595 12.1661C13.1595 12.4302 13.4025 12.6698 13.6667 12.6661H14V14.9994H4V12.6661H4.33334C4.59749 12.6697 4.84046 12.4302 4.84046 12.1661C4.84046 11.9019 4.59749 11.6623 4.33334 11.6661H3.5C3.227 11.6677 2.99904 11.9287 3 12.1661Z" fill="#111827" stroke="#111827" strokeWidth="0.2" />
      <path d="M8.99957 14C9.11874 13.9953 9.25647 13.9463 9.34334 13.8646L12.1768 11.1979C12.3392 11.0172 12.4062 10.6707 12.2185 10.4687C12.0336 10.2698 11.6749 10.2757 11.4893 10.4739L9.49959 12.3489L9.49959 1.83332C9.49959 1.55719 9.27572 1.33333 8.99957 1.33333C8.72342 1.33333 8.49956 1.55719 8.49956 1.83332L8.49956 12.3489L6.50987 10.4739C6.33896 10.3033 5.96771 10.2718 5.78067 10.4687C5.59366 10.6657 5.65341 11.0246 5.82236 11.1979L8.65581 13.8646C8.75277 13.9558 8.86654 14.0003 8.99957 14Z" fill="#111827" stroke="#111827" strokeWidth="0.2" />
    </svg>
  )
}

export const ProductListCamera = (color) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M16.688 3.87411H11.9234L10.9613 2.25778C10.8671 2.09975 10.6969 2.00293 10.5129 2.00293H7.48694C7.30302 2.00293 7.13269 2.09975 7.03862 2.25778L6.0765 3.87411H4.513V3.51787C4.513 3.22974 4.27941 2.99615 3.99129 2.99615H2.0609C1.77272 2.99615 1.53919 3.22974 1.53919 3.51787V3.87411H1.31192C0.587313 3.87411 0 4.46148 0 5.18597V14.6845C0 15.4091 0.587313 15.9965 1.31186 15.9965H16.688C17.4126 15.9965 17.9999 15.4091 17.9999 14.6845V5.18597C18 4.46148 17.4126 3.87411 16.688 3.87411ZM8.99994 13.6695C6.93758 13.6695 5.26573 11.9976 5.26573 9.9352C5.26573 7.8729 6.93758 6.20098 8.99994 6.20098C11.0623 6.20098 12.7342 7.8729 12.7342 9.9352C12.7342 11.9976 11.0623 13.6695 8.99994 13.6695ZM15.8695 6.57878H14.2347C13.9466 6.57878 13.713 6.34519 13.713 6.05701C13.713 5.76883 13.9466 5.53524 14.2347 5.53524H15.8695C16.1578 5.53524 16.3913 5.76883 16.3913 6.05701C16.3913 6.34519 16.1577 6.57878 15.8695 6.57878Z" fill="#1D3148" />
    <path d="M8.99936 12.5436C10.4401 12.5436 11.6081 11.3757 11.6081 9.9349C11.6081 8.49414 10.4401 7.32617 8.99936 7.32617C7.55859 7.32617 6.39062 8.49414 6.39062 9.9349C6.39062 11.3757 7.55859 12.5436 8.99936 12.5436Z" fill="#1D3148" />
  </svg>)
}
export const ProductListSearch = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M15.8104 14.7887L13.1976 12.203C15.1805 9.73378 14.9939 6.09983 12.731 3.84027C11.5413 2.65225 9.97828 2 8.29865 2C6.61901 2 5.03268 2.65225 3.84294 3.84027C2.65319 5.02829 2 6.58902 2 8.28952C2 9.99002 2.65319 11.5507 3.84294 12.7388C5.03268 13.9035 6.59568 14.579 8.29865 14.579C9.72167 14.579 11.1214 14.0899 12.2178 13.2047L14.8072 15.7903C14.9472 15.9301 15.1105 16 15.2971 16C15.4838 16 15.6704 15.9301 15.787 15.7903C16.067 15.5108 16.067 15.0682 15.8104 14.7887ZM13.1976 8.28952C13.1976 9.59401 12.6844 10.8286 11.7512 11.7371C10.8181 12.6456 9.60503 13.1814 8.29865 13.1814C6.99226 13.1814 5.75586 12.6689 4.84605 11.7371C3.93625 10.8053 3.3997 9.59401 3.3997 8.28952C3.3997 6.98503 3.91292 5.75042 4.84605 4.84193C5.77919 3.93344 6.96893 3.39767 8.29865 3.39767C9.60503 3.39767 10.8414 3.91015 11.7512 4.84193C12.661 5.77371 13.1976 6.96173 13.1976 8.28952Z" fill="white" stroke="white" strokeWidth="0.5" />
    </svg>
  )
}

export const ProductListDelivery = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_1317_5633)">
        <path d="M4.895 11.8906C6.28512 11.8906 7.41602 13.0215 7.41602 14.4116C7.41602 15.8018 6.28512 16.9327 4.895 16.9327C3.50465 16.9327 2.37399 15.8018 2.37399 14.4116C2.37399 13.0215 3.50488 11.8906 4.895 11.8906ZM4.895 15.6721C5.59016 15.6721 6.15551 15.1068 6.15551 14.4116C6.15551 13.7165 5.59016 13.1511 4.895 13.1511C4.19984 13.1511 3.63449 13.7165 3.63449 14.4116C3.63449 15.1068 4.19984 15.6721 4.895 15.6721Z" fill="white" />
        <path d="M13.5083 11.8906C14.8984 11.8906 16.0293 13.0215 16.0293 14.4116C16.0293 15.8018 14.8984 16.9327 13.5083 16.9327C12.1182 16.9327 10.9873 15.8018 10.9873 14.4116C10.9873 13.0215 12.1182 11.8906 13.5083 11.8906ZM13.5083 15.6721C14.2034 15.6721 14.7688 15.1068 14.7688 14.4116C14.7688 13.7165 14.2034 13.1511 13.5083 13.1511C12.8133 13.1511 12.2478 13.7165 12.2478 14.4116C12.2478 15.1068 12.8131 15.6721 13.5083 15.6721Z" fill="white" />
        <path d="M3.1975 4.67471C3.30465 4.46189 3.5225 4.32764 3.76074 4.32764H7.08008V5.58814H4.14941L2.43324 9.00158L1.30676 8.43518L3.1975 4.67471Z" fill="white" />
        <path d="M6.78578 13.8027H11.5547V15.0632H6.78578V13.8027Z" fill="white" />
        <path d="M15.3993 13.8027H17.5841C17.9322 13.8027 18.2144 14.0849 18.2144 14.433C18.2144 14.7811 17.9322 15.0632 17.5841 15.0632H15.3992C15.0511 15.0632 14.769 14.7811 14.769 14.433C14.769 14.0848 15.0512 13.8027 15.3993 13.8027Z" fill="white" />
        <path d="M0.132441 9.94973L1.37213 8.35309C1.49123 8.1993 1.67506 8.10937 1.86982 8.10937H6.44967V3.69762C6.44967 3.34949 6.73182 3.06738 7.0799 3.06738H17.5841C17.9322 3.06738 18.2144 3.34953 18.2144 3.69762C18.2144 4.0457 17.9322 4.32785 17.5841 4.32785H7.71018V8.73961C7.71018 9.08773 7.42803 9.36984 7.07994 9.36984H2.17846L1.2606 10.5522V13.8026H3.00432C3.35244 13.8026 3.63455 14.0848 3.63455 14.4328C3.63455 14.781 3.3524 15.0631 3.00432 15.0631H0.630371C0.282246 15.0631 0.000137329 14.7809 9.72748e-05 14.4328V10.3363C9.72748e-05 10.1964 0.0467377 10.0602 0.132441 9.94973Z" fill="white" />
        <path d="M15.4413 10.6094H18.3405C18.6886 10.6094 18.9707 10.8915 18.9707 11.2396C18.9707 11.5877 18.6886 11.8698 18.3405 11.8698H15.4413C15.0932 11.8698 14.8111 11.5877 14.8111 11.2396C14.8111 10.8915 15.0932 10.6094 15.4413 10.6094Z" fill="white" />
        <path d="M13.9916 8.13037H19.3698C19.7179 8.13037 20 8.41252 20 8.76064C20 9.10877 19.7179 9.39088 19.3698 9.39088H13.9916C13.6435 9.39088 13.3614 9.10873 13.3614 8.76064C13.3614 8.41256 13.6435 8.13037 13.9916 8.13037Z" fill="white" />
        <path d="M12.9623 5.65137H18.3405C18.6886 5.65137 18.9707 5.93352 18.9707 6.2816C18.9707 6.62973 18.6886 6.91184 18.3405 6.91184H12.9623C12.6142 6.91184 12.3321 6.62969 12.3321 6.2816C12.332 5.93352 12.6142 5.65137 12.9623 5.65137Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_1317_5633">
          <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
        </clipPath>
      </defs>
    </svg>
  )
}



export const ProductDetailsRating = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 15" fill="none">
      <g clipPath="url(#clip0_565_20480)">
        <path d="M13.9635 5.87072C13.8719 5.58723 13.6204 5.38589 13.3229 5.35908L9.28216 4.99217L7.68432 1.25229C7.56651 0.9782 7.29819 0.800781 7.00007 0.800781C6.70195 0.800781 6.43364 0.9782 6.31582 1.25293L4.71798 4.99217L0.67656 5.35908C0.379616 5.38653 0.128816 5.58723 0.0366355 5.87072C-0.0555452 6.1542 0.0295858 6.46514 0.254216 6.66115L3.30857 9.33983L2.40791 13.3072C2.34201 13.5989 2.45523 13.9005 2.69727 14.0754C2.82737 14.1694 2.97958 14.2173 3.13307 14.2173C3.26542 14.2173 3.39669 14.1816 3.51451 14.1111L7.00007 12.0279L10.4844 14.1111C10.7393 14.2645 11.0607 14.2505 11.3022 14.0754C11.5444 13.8999 11.6575 13.5983 11.5916 13.3072L10.6909 9.33983L13.7453 6.66168C13.9699 6.46514 14.0557 6.15474 13.9635 5.87072Z" fill="#FF9100" />
      </g>
      <defs>
        <clipPath id="clip0_565_20480">
          <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ProductListShippingAdd = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M11.4999 6.49999H7.50001V2.49997C7.50001 2.22403 7.27599 2 6.99995 2C6.72402 2 6.49999 2.22403 6.49999 2.49997V6.49999H2.49997C2.22403 6.49999 2 6.72402 2 6.99995C2 7.27599 2.22403 7.50001 2.49997 7.50001H6.49999V11.4999C6.49999 11.776 6.72402 12 6.99995 12C7.27599 12 7.50001 11.776 7.50001 11.4999V7.50001H11.4999C11.776 7.50001 12 7.27599 12 6.99995C12 6.72402 11.776 6.49999 11.4999 6.49999Z" fill="#121212" stroke="#121212" stroke-width="0.2" />
    </svg>
  )
}

export const ProductDetailsButtonAdd = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path d="M6.46023 11.9202V0.999733" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 6.45996H11.9205" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const ProductDetailsButtonAddNote = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 14 14" fill="none">
      <g clip-path="url(#clip0_1366_4445)">
        <path d="M12.3999 6.39998H7.60002V1.59996C7.60002 1.26883 7.33118 1 6.99995 1C6.66882 1 6.39998 1.26883 6.39998 1.59996V6.39998H1.59996C1.26883 6.39998 1 6.66882 1 6.99995C1 7.33118 1.26883 7.60002 1.59996 7.60002H6.39998V12.3999C6.39998 12.7312 6.66882 13 6.99995 13C7.33118 13 7.60002 12.7312 7.60002 12.3999V7.60002H12.3999C12.7312 7.60002 13 7.33118 13 6.99995C13 6.66882 12.7312 6.39998 12.3999 6.39998Z" fill="#121212" stroke="#121212" stroke-width="0.5" />
      </g>
      <defs>
        <clipPath id="clip0_1366_4445">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ProductDetailsCostInfo = (color) => {
  return (
    <svg style={{ paddingTop: '1px' }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M6.99984 9.33317V6.99984M6.99984 4.6665H7.00567M12.8332 6.99984C12.8332 10.2215 10.2215 12.8332 6.99984 12.8332C3.77818 12.8332 1.1665 10.2215 1.1665 6.99984C1.1665 3.77818 3.77818 1.1665 6.99984 1.1665C10.2215 1.1665 12.8332 3.77818 12.8332 6.99984Z" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
export const CopyToClipboardIcon = (color) => {
  return (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="14" height="14" viewBox="0 0 561 561" >
      <g>
        <g id="content-copy">
          <path d="M395.25,0h-306c-28.05,0-51,22.95-51,51v357h51V51h306V0z M471.75,102h-280.5c-28.05,0-51,22.95-51,51v357
			c0,28.05,22.95,51,51,51h280.5c28.05,0,51-22.95,51-51V153C522.75,124.95,499.8,102,471.75,102z M471.75,510h-280.5V153h280.5V510
			z"/>
        </g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
    </svg>
  )
}
export const TickIcon = (color) => {
  return (
    <svg id="Layer_1" enable-background="new 0 0 24 24" height="14" viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
      <switch>
        <g>
          <path d="m9.8 18c-.3 0-.5-.1-.7-.3l-4.9-5.2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4.1 4.4 8.4-9.2c.3-.4 1-.5 1.4-.2s.5 1 .2 1.4l-.1.1-9.1 10c-.1.3-.4.4-.7.4z" fill="#02bc7d" />
        </g>
      </switch>
    </svg>

  )
}

export const ArrowUpIcon = (color) => {
  return (
    < svg width="10" height="10" viewBox="0 0 10 10" fill="none" >
      <g clip-path="url(#clip0_1412_3037)">
        <path d="M4.99991 2.21777L0.398681 6.819L1.36229 7.78262L4.99991 4.14498L8.63753 7.78262L9.60114 6.819L4.99991 2.21777Z" fill="#1B3048" fill-opacity="0.7" />
      </g>
      <defs>
        <clipPath id="clip0_1412_3037">
          <rect width="10" height="10" fill="white" transform="matrix(1 8.74228e-08 8.74228e-08 -1 0 10)" />
        </clipPath>
      </defs>
    </svg >
  )
}

export const ArrowDownIcon = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <g clip-path="url(#clip0_1412_3051)">
        <path d="M5.00009 7.78223L9.60132 3.181L8.63771 2.21738L5.00009 5.85502L1.36247 2.21738L0.398858 3.181L5.00009 7.78223Z" fill="#1B3048" fill-opacity="0.7" />
      </g>
      <defs>
        <clipPath id="clip0_1412_3051">
          <rect width="10" height="10" fill="white" transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 10 0)" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const WordPressIcon = (color) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_656_3889)">
        <path
          d="M4.79867 4.93828H3.9151L6.32396 11.7476L7.67251 7.89386L6.62697 4.93828H5.69472V4.28945H9.82301V4.93828H8.85627L11.2651 11.7476L12.131 9.27312C13.2668 6.10288 11.2 5.11534 11.2 4.40783C11.2 3.70031 11.7736 3.12679 12.481 3.12679C12.5193 3.12679 12.5565 3.12886 12.5929 3.13225C11.3942 2.00061 9.77773 1.30664 7.99907 1.30664C5.67499 1.30664 3.62782 2.49129 2.42773 4.28945H4.7986V4.93828H4.79867Z"
          fill="#00769D"
        />
        <path
          d="M1.30664 7.99954C1.30664 10.5623 2.74705 12.7882 4.86219 13.9131L1.84142 5.37402C1.49732 6.18018 1.30664 7.06758 1.30664 7.99954Z"
          fill="#00769D"
        />
        <path
          d="M13.8258 4.70117C13.9215 5.26494 13.8925 5.89858 13.7456 6.53468H13.7722L13.671 6.8239C13.611 7.03273 13.5355 7.24635 13.4497 7.45625L11.1465 13.9088C13.2572 12.7827 14.6939 10.5591 14.6939 7.99961C14.6939 6.80027 14.3782 5.67477 13.8258 4.70117Z"
          fill="#00769D"
        />
        <path
          d="M5.93555 14.3683C6.58584 14.579 7.27949 14.6932 7.99998 14.6932C8.68719 14.6932 9.35014 14.5895 9.97424 14.3971L8.01624 8.8623L5.93555 14.3683Z"
          fill="#00769D"
        />
        <path
          d="M13.6568 2.34313C12.1458 0.832141 10.1368 0 7.99996 0C5.86309 0 3.85413 0.832141 2.34313 2.34313C0.832141 3.85413 0 5.86309 0 8C0 10.1369 0.832141 12.1458 2.34313 13.6568C3.85413 15.1678 5.86312 16 8 16C10.1369 16 12.1458 15.1678 13.6569 13.6568C15.1679 12.1458 16 10.1368 16 8C16 5.86309 15.1678 3.85413 13.6568 2.34313ZM7.99996 15.4356C3.89995 15.4356 0.564339 12.1 0.564339 8C0.564339 3.89998 3.89995 0.564339 7.99996 0.564339C12.1 0.564339 15.4356 3.89998 15.4356 8C15.4356 12.1 12.1 15.4356 7.99996 15.4356Z"
          fill="#00769D"
        />
      </g>
      <defs>
        <clipPath id="clip0_656_3889">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const DefaultShopIcon = (color) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_656_3921)">
        <path
          d="M13.3071 3.08092C13.296 3.00014 13.2253 2.95545 13.1669 2.95058C13.1086 2.9457 11.9696 2.92839 11.9696 2.92839C11.9696 2.92839 11.0171 2.0033 10.923 1.90914C10.8289 1.81498 10.6451 1.84355 10.5738 1.86455C10.5727 1.86486 10.395 1.91989 10.0951 2.01273C10.0451 1.85017 9.97126 1.65052 9.86608 1.44989C9.52689 0.802891 9.03036 0.460422 8.4302 0.459547C8.42951 0.459547 8.42889 0.459547 8.42817 0.459547C8.38658 0.459547 8.34511 0.463454 8.30361 0.467235C8.28598 0.445985 8.26814 0.424922 8.24936 0.404829C7.98808 0.125172 7.65255 -0.0110777 7.25095 0.000703511C6.4757 0.0229223 5.70405 0.582703 5.07814 1.57683C4.63755 2.27652 4.30283 3.15548 4.20764 3.83577C3.3177 4.11136 2.69505 4.3042 2.68158 4.30842C2.23236 4.44939 2.21823 4.46352 2.15933 4.88673C2.11473 5.20714 0.939453 14.2965 0.939453 14.2965L10.7905 16L15.06 14.9387C15.06 14.9387 13.3181 3.1617 13.3071 3.08092ZM4.75952 3.66483C5.02589 2.41933 6.06952 0.550797 7.26586 0.516391C7.44786 0.512578 7.60114 0.552516 7.73205 0.638672C7.52267 0.747391 7.32014 0.903641 7.13017 1.10739C6.6378 1.63558 6.26064 2.4557 6.11023 3.24655C5.64086 3.39189 5.18183 3.53405 4.75952 3.66483ZM8.32183 2.56177C7.80577 2.72155 7.24236 2.89602 6.67717 3.07102C6.8363 2.46233 7.13748 1.8563 7.50761 1.45927C7.6453 1.31158 7.83792 1.14677 8.06598 1.05267C8.28055 1.49977 8.32702 2.13358 8.32183 2.56177ZM8.83714 2.4022C8.83142 2.00967 8.78455 1.4637 8.6017 0.991735C9.18986 1.10317 9.47945 1.76867 9.60167 2.16548C9.37502 2.23564 9.11683 2.31558 8.83714 2.4022Z"
          fill="#95BF47"
        />
        <path
          d="M13.1672 2.95091C13.1088 2.94604 11.9699 2.92873 11.9699 2.92873C11.9699 2.92873 11.0174 2.00363 10.9233 1.90948C10.8882 1.87435 10.8406 1.85638 10.791 1.84863L10.7913 16.0002L15.0603 14.9391C15.0603 14.9391 13.3184 3.16204 13.3073 3.08126C13.2963 3.00048 13.2255 2.95579 13.1672 2.95091Z"
          fill="#5E8E3E"
        />
        <path
          d="M8.42523 5.14553L7.92933 7.00057C7.92933 7.00057 7.3762 6.74869 6.72042 6.7901C5.75889 6.85082 5.74867 7.45735 5.75827 7.60935C5.81064 8.439 7.9932 8.62028 8.11589 10.5635C8.21242 12.0923 7.30498 13.138 5.99745 13.2206C4.42842 13.3197 3.56445 12.3938 3.56445 12.3938L3.89692 10.9793C3.89692 10.9793 4.76639 11.6353 5.46239 11.5913C5.91702 11.5626 6.07945 11.1929 6.06295 10.9314C5.99461 9.84913 4.21736 9.91288 4.10508 8.13466C4.01058 6.63803 4.99333 5.12188 7.16183 4.98494C7.99736 4.93222 8.42523 5.14553 8.42523 5.14553Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_656_3921">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const AllAddressIcon = (color)=> {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
            <path d="M14.136 1H3.864C3.3698 1.00053 2.89599 1.19708 2.54654 1.54654C2.19708 1.89599 2.00053 2.3698 2 2.864V4H1.5C1.36739 4 1.24021 4.05268 1.14645 4.14645C1.05268 4.24021 1 4.36739 1 4.5C1 4.63261 1.05268 4.75979 1.14645 4.85355C1.24021 4.94732 1.36739 5 1.5 5H2V8H1.5C1.36739 8 1.24021 8.05268 1.14645 8.14645C1.05268 8.24021 1 8.36739 1 8.5C1 8.63261 1.05268 8.75979 1.14645 8.85355C1.24021 8.94732 1.36739 9 1.5 9H2V13H1.5C1.36739 13 1.24021 13.0527 1.14645 13.1464C1.05268 13.2402 1 13.3674 1 13.5C1 13.6326 1.05268 13.7598 1.14645 13.8536C1.24021 13.9473 1.36739 14 1.5 14H2V13H1.5C1.36739 13 1.24021 13.0527 1.14645 13.1464C1.05268 13.2402 1 13.3674 1 13.5C1 13.6326 1.05268 13.7598 1.14645 13.8536C1.24021 13.9473 1.36739 14 1.5 14H2V15.136C2.00053 15.6302 2.19708 16.104 2.54654 16.4535C2.89599 16.8029 3.3698 16.9995 3.864 17H14.136C14.6302 16.9995 15.104 16.8029 15.4535 16.4535C15.8029 16.104 15.9995 15.6302 16 15.136V2.864C15.9995 2.3698 15.8029 1.89599 15.4535 1.54654C15.104 1.19708 14.6302 1.00053 14.136 1ZM15 15.136C14.9997 15.3651 14.9086 15.5847 14.7466 15.7466C14.5847 15.9086 14.3651 15.9997 14.136 16H3.864C3.63493 15.9997 3.41533 15.9086 3.25335 15.7466C3.09138 15.5847 3.00026 15.3651 3 15.136V14H3.5C3.63261 14 3.75979 13.9473 3.85355 13.8536C3.94732 13.7598 4 13.6326 4 13.5C4 13.3674 3.94732 13.2402 3.85355 13.1464C3.75979 13.0527 3.63261 13 3.5 13H3V14H3.5C3.63261 14 3.75979 13.9473 3.85355 13.8536C3.94732 13.7598 4 13.6326 4 13.5C4 13.3674 3.94732 13.2402 3.85355 13.1464C3.75979 13.0527 3.63261 13 3.5 13H3V9H3.5C3.63261 9 3.75979 8.94732 3.85355 8.85355C3.94732 8.75979 4 8.63261 4 8.5C4 8.36739 3.94732 8.24021 3.85355 8.14645C3.75979 8.05268 3.63261 8 3.5 8H3V5H3.5C3.63261 5 3.75979 4.94732 3.85355 4.85355C3.94732 4.75979 4 4.63261 4 4.5C4 4.36739 3.94732 4.24021 3.85355 4.14645C3.75979 4.05268 3.63261 4 3.5 4H3V2.864C3.00026 2.63493 3.09138 2.41533 3.25335 2.25335C3.41533 2.09138 3.63493 2.00026 3.864 2H14.136C14.3651 2.00026 14.5847 2.09138 14.7466 2.25335C14.9086 2.41533 14.9997 2.63493 15 2.864V15.136Z" fill="#F37B78"/>
            <path d="M2 13V9H1.5C1.36739 9 1.24021 8.94732 1.14645 8.85355C1.05268 8.75979 1 8.63261 1 8.5C1 8.36739 1.05268 8.24021 1.14645 8.14645C1.24021 8.05268 1.36739 8 1.5 8H2V5H1.5C1.36739 5 1.24021 4.94732 1.14645 4.85355C1.05268 4.75979 1 4.63261 1 4.5C1 4.36739 1.05268 4.24021 1.14645 4.14645C1.24021 4.05268 1.36739 4 1.5 4H2V2.864C2.00053 2.3698 2.19708 1.89599 2.54654 1.54654C2.89599 1.19708 3.3698 1.00053 3.864 1H14.136C14.6302 1.00053 15.104 1.19708 15.4535 1.54654C15.8029 1.89599 15.9995 2.3698 16 2.864V15.136C15.9995 15.6302 15.8029 16.104 15.4535 16.4535C15.104 16.8029 14.6302 16.9995 14.136 17H3.864C3.3698 16.9995 2.89599 16.8029 2.54654 16.4535C2.19708 16.104 2.00053 15.6302 2 15.136V14M2 13H1.5C1.36739 13 1.24021 13.0527 1.14645 13.1464C1.05268 13.2402 1 13.3674 1 13.5C1 13.6326 1.05268 13.7598 1.14645 13.8536C1.24021 13.9473 1.36739 14 1.5 14H2M2 13V14M3 14V15.136C3.00026 15.3651 3.09138 15.5847 3.25335 15.7466C3.41533 15.9086 3.63493 15.9997 3.864 16H14.136C14.3651 15.9997 14.5847 15.9086 14.7466 15.7466C14.9086 15.5847 14.9997 15.3651 15 15.136V2.864C14.9997 2.63493 14.9086 2.41533 14.7466 2.25335C14.5847 2.09138 14.3651 2.00026 14.136 2H3.864C3.63493 2.00026 3.41533 2.09138 3.25335 2.25335C3.09138 2.41533 3.00026 2.63493 3 2.864V4H3.5C3.63261 4 3.75979 4.05268 3.85355 4.14645C3.94732 4.24021 4 4.36739 4 4.5C4 4.63261 3.94732 4.75979 3.85355 4.85355C3.75979 4.94732 3.63261 5 3.5 5H3V8H3.5C3.63261 8 3.75979 8.05268 3.85355 8.14645C3.94732 8.24021 4 8.36739 4 8.5C4 8.63261 3.94732 8.75979 3.85355 8.85355C3.75979 8.94732 3.63261 9 3.5 9H3V13M3 14H3.5C3.63261 14 3.75979 13.9473 3.85355 13.8536C3.94732 13.7598 4 13.6326 4 13.5C4 13.3674 3.94732 13.2402 3.85355 13.1464C3.75979 13.0527 3.63261 13 3.5 13H3M3 14V13" stroke="#F37B78" stroke-width="0.4"/>
            <path d="M9.50049 9.00049C9.99494 9.00049 10.4783 8.85387 10.8894 8.57916C11.3005 8.30446 11.621 7.91401 11.8102 7.4572C11.9994 7.00038 12.0489 6.49772 11.9525 6.01276C11.856 5.52781 11.6179 5.08235 11.2683 4.73272C10.9186 4.38309 10.4732 4.14499 9.98821 4.04853C9.50326 3.95206 9.00059 4.00157 8.54378 4.19079C8.08696 4.38001 7.69652 4.70044 7.42181 5.11156C7.14711 5.52269 7.00049 6.00604 7.00049 6.50049C7.00128 7.16329 7.26493 7.79871 7.7336 8.26738C8.20227 8.73605 8.83769 8.9997 9.50049 9.00049ZM9.50049 5.00049C9.79716 5.00049 10.0872 5.08846 10.3338 5.25329C10.5805 5.41811 10.7728 5.65237 10.8863 5.92646C10.9998 6.20055 11.0295 6.50215 10.9717 6.79312C10.9138 7.0841 10.7709 7.35137 10.5611 7.56115C10.3514 7.77093 10.0841 7.91379 9.79312 7.97167C9.50215 8.02955 9.20055 7.99984 8.92646 7.88631C8.65237 7.77278 8.41811 7.58052 8.25328 7.33384C8.08846 7.08717 8.00049 6.79716 8.00049 6.50049C8.00049 6.10266 8.15852 5.72113 8.43983 5.43983C8.72113 5.15852 9.10266 5.00049 9.50049 5.00049Z" fill="#F37B78" stroke="#F37B78" stroke-width="0.4"/>
            <path d="M9.5 9.49902C8.4395 9.50021 7.42278 9.92202 6.67289 10.6719C5.923 11.4218 5.50119 12.4385 5.5 13.499C5.5 13.6316 5.55268 13.7588 5.64645 13.8526C5.74021 13.9463 5.86739 13.999 6 13.999H13C13.1326 13.999 13.2598 13.9463 13.3536 13.8526C13.4473 13.7588 13.5 13.6316 13.5 13.499C13.4988 12.4385 13.077 11.4218 12.3271 10.6719C11.5772 9.92202 10.5605 9.50021 9.5 9.49902ZM6.5415 12.999C6.65909 12.2994 7.02082 11.6641 7.56245 11.2059C8.10408 10.7477 8.79056 10.4963 9.5 10.4963C10.2094 10.4963 10.8959 10.7477 11.4375 11.2059C11.9792 11.6641 12.3409 12.2994 12.4585 12.999H6.5415Z" fill="#F37B78" stroke="#F37B78" stroke-width="0.4"/>
        </svg>
    )
}
export const RedIcon = (color) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
    >
      <circle cx="3" cy="3" r="3" fill="#FF4C4C" />
    </svg>
  )
}

export const YellowIcon = (color)=> {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
      <circle cx="3" cy="3" r="3" fill="#FFB800"/>
    </svg>
  )
}

export const ChangeIcon = (color)=> {
    return (
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
             fill="black"
             width="16"
             height="16"
             viewBox="0 0 512 512">
<g>
	<g>
		<path d="M493.815,70.629c-11.001-1.003-20.73,7.102-21.733,18.102l-2.65,29.069C424.473,47.194,346.429,0,256,0
			C158.719,0,72.988,55.522,30.43,138.854c-5.024,9.837-1.122,21.884,8.715,26.908c9.839,5.024,21.884,1.123,26.908-8.715
			C102.07,86.523,174.397,40,256,40c74.377,0,141.499,38.731,179.953,99.408l-28.517-20.367c-8.989-6.419-21.48-4.337-27.899,4.651
			c-6.419,8.989-4.337,21.479,4.651,27.899l86.475,61.761c12.674,9.035,30.155,0.764,31.541-14.459l9.711-106.53
			C512.919,81.362,504.815,71.632,493.815,70.629z"/>
	</g>
</g>
            <g>
	<g>
		<path d="M472.855,346.238c-9.838-5.023-21.884-1.122-26.908,8.715C409.93,425.477,337.603,472,256,472
			c-74.377,0-141.499-38.731-179.953-99.408l28.517,20.367c8.989,6.419,21.479,4.337,27.899-4.651
			c6.419-8.989,4.337-21.479-4.651-27.899l-86.475-61.761c-12.519-8.944-30.141-0.921-31.541,14.459l-9.711,106.53
			c-1.003,11,7.102,20.73,18.101,21.733c11.014,1.001,20.731-7.112,21.733-18.102l2.65-29.069C87.527,464.806,165.571,512,256,512
			c97.281,0,183.012-55.522,225.57-138.854C486.594,363.309,482.692,351.262,472.855,346.238z"/>
	</g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
            <g>
</g>
</svg>
    )
}

export const GreenIcon = (color) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
    >
      <circle cx="3" cy="3" r="3" fill="#88B34C" />
    </svg>
  )
}

export const FrontArrow = (color)=> {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"

        >
            <g clip-path="url(#clip0_644_3809)">
                <path
                    d="M7.7832 4.99967L3.18197 0.398437L2.21836 1.36205L5.856 4.99967L2.21836 8.63728L3.18197 9.6009L7.7832 4.99967Z"
                    fill="#1B3048"
                    fill-opacity="0.7"
                />
            </g>
            <defs>
                <clipPath id="clip0_644_3809">
                    <rect
                        width="10"
                        height="10"
                        fill="white"
                        transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Product_card_price_info = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath="url(#clip0_614_3830)">
        <path d="M6.99935 9.33366V7.00032M6.99935 4.66699H7.00518M12.8327 7.00032C12.8327 10.222 10.221 12.8337 6.99935 12.8337C3.77769 12.8337 1.16602 10.222 1.16602 7.00032C1.16602 3.77866 3.77769 1.16699 6.99935 1.16699C10.221 1.16699 12.8327 3.77866 12.8327 7.00032Z" stroke="#4D4D4D" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_614_3830">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ProductModalShipping = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19" fill="none">
      <path d="M17.5178 12.2844C17.3383 12.2171 17.1363 12.3292 17.0915 12.5088C16.7773 13.5409 16.2164 14.4833 15.5208 15.3135C14.9823 14.9994 14.3764 14.7077 13.7257 14.4833C13.9725 13.7204 14.152 12.8902 14.2642 12.0151C14.2867 11.8132 14.152 11.6561 13.9501 11.6337C13.7706 11.6112 13.5911 11.7459 13.5686 11.9478C13.4789 12.778 13.2994 13.5634 13.0526 14.2814C12.1101 14.0346 11.1004 13.8775 10.0683 13.8551V12.6658C11.3472 11.9478 12.1775 11.2522 12.1999 11.2298C12.357 11.0951 12.357 10.8932 12.2448 10.7361C12.1101 10.5791 11.9082 10.5791 11.7511 10.6912C11.6838 10.781 6.63519 14.977 2.43922 13.137C2.03533 12.9575 1.63144 12.7331 1.24998 12.419C0.935848 12.1273 0.733903 11.858 0.666588 11.5888C0.890971 11.7459 1.22755 11.858 1.65388 11.9254C1.67631 11.9254 1.69875 11.9478 1.74363 11.9478C1.96801 11.9927 2.21483 12.0375 2.50653 12.06C6.47812 12.4414 10.5619 8.94106 10.7414 8.80643C10.876 8.6718 10.8985 8.46985 10.7863 8.31279C10.6517 8.17815 10.4497 8.15572 10.2926 8.26791C10.2926 8.26791 10.2253 8.33522 10.1131 8.40254V2.52369C10.1356 2.52369 10.1804 2.52369 10.2029 2.52369H10.2702L10.9658 2.59101L11.0555 2.61344C11.1453 2.63588 11.2126 2.63588 11.3024 2.65832L11.4819 2.7032C11.6614 2.74807 11.8633 2.63588 11.9082 2.45638C11.9531 2.27687 11.8409 2.07492 11.6614 2.03005L11.437 1.98517C11.3472 1.96273 11.2575 1.96273 11.1902 1.94029L11.1004 1.91786L10.3375 1.8281H10.2702C10.1356 1.8281 10.0009 1.80566 9.84387 1.80566V1.8281C9.82143 1.8281 9.799 1.80566 9.77656 1.80566C9.75412 1.80566 9.75412 1.80566 9.75412 1.80566H9.73168C7.42053 1.8281 5.26645 2.77051 3.67333 4.45339C2.41678 5.79969 1.63144 7.52744 1.42949 9.36739C0.599273 9.83859 0.105629 10.422 0.0158756 11.0727C-0.0738778 11.701 0.217821 12.3068 0.868533 12.9126C1.27242 13.2268 1.69875 13.4736 2.12508 13.6756C2.50653 14.5282 3.02261 15.3135 3.67333 15.9867C5.26645 17.6696 7.42053 18.612 9.73168 18.6344H9.77656C12.0877 18.612 14.2418 17.6696 15.8349 15.9867C16.71 15.0443 17.3832 13.9224 17.7422 12.7107C17.8095 12.5312 17.7197 12.3517 17.5178 12.2844ZM2.52897 11.342C2.34946 11.3195 2.1924 11.2971 2.05777 11.2746C2.03533 11.0503 2.01289 10.8034 1.99045 10.5791H5.0645C5.0645 10.7361 5.0645 10.8932 5.08694 11.0503C4.25672 11.2971 3.38163 11.4317 2.52897 11.342ZM5.76009 10.6015H6.43324C6.20886 10.6912 5.98448 10.781 5.76009 10.8708C5.78253 10.7586 5.76009 10.6688 5.76009 10.6015ZM7.84686 9.88347H5.76009C5.80497 8.44741 6.02935 7.05624 6.45568 5.867C7.12883 3.98218 8.18343 2.77051 9.35023 2.54613V8.89618C8.96878 9.21032 8.45269 9.54689 7.84686 9.88347ZM4.07722 4.94703C5.01963 3.93731 6.18642 3.24172 7.46541 2.83783C6.79226 3.48854 6.2313 4.45339 5.80497 5.62018C5.3562 6.89917 5.10938 8.35766 5.0645 9.86103H1.99045C1.99045 9.77128 1.99045 9.68152 1.99045 9.59177C2.14752 7.88646 2.88798 6.22602 4.07722 4.94703ZM1.29486 10.2874C1.29486 10.5791 1.3173 10.8483 1.33974 11.14C0.913409 11.0054 0.868533 10.8483 0.868533 10.8483C0.846094 10.7361 1.0256 10.5117 1.29486 10.2874ZM14.6232 16.1886C14.511 16.2784 14.3989 16.3682 14.2867 16.4579C14.1969 16.5252 14.1072 16.5925 14.0174 16.6598C13.9052 16.7272 13.793 16.8169 13.6584 16.8842C13.5686 16.9515 13.4564 16.9964 13.3667 17.0637C13.2545 17.1311 13.1199 17.1984 12.9852 17.2432C12.8955 17.2881 12.7833 17.333 12.6935 17.3779C12.5589 17.4228 12.4243 17.4901 12.2897 17.5349C12.1775 17.5798 12.0877 17.6023 11.9755 17.6471C11.9531 17.6471 11.9531 17.6471 11.9306 17.6696C12.5365 17.0862 13.0526 16.2335 13.4564 15.2014C14.0174 15.3809 14.5335 15.6052 15.0047 15.8745C14.9598 15.9194 14.9149 15.9643 14.8701 16.0091C14.8027 16.0316 14.713 16.1213 14.6232 16.1886ZM7.12883 17.5125C6.9942 17.4676 6.85957 17.4228 6.72494 17.3554C6.63519 17.3106 6.523 17.2657 6.43324 17.2208C6.29861 17.1535 6.18642 17.1086 6.05179 17.0413C5.96204 16.9964 5.87228 16.9291 5.76009 16.8842C5.6479 16.8169 5.51327 16.7272 5.40108 16.6598C5.31133 16.5925 5.22157 16.5252 5.13182 16.4579C5.01963 16.3682 4.90744 16.2784 4.79524 16.1886C4.70549 16.1213 4.61574 16.054 4.54842 15.9643C4.50355 15.9194 4.45867 15.8745 4.41379 15.8296C4.885 15.5604 5.40108 15.336 5.9396 15.1565C6.34349 16.1886 6.85957 17.0189 7.46541 17.6247C7.44297 17.6247 7.44297 17.6247 7.42053 17.6023C7.30834 17.5798 7.21859 17.5574 7.12883 17.5125ZM9.37267 17.9164C8.29563 17.7145 7.2859 16.6598 6.61275 14.9545C7.48785 14.7302 8.40782 14.5955 9.37267 14.5506V17.9164ZM12.8282 14.9545C12.155 16.6598 11.1453 17.7145 10.0683 17.9164V14.5731C11.0107 14.5955 11.9531 14.7302 12.8282 14.9545ZM9.37267 13.8775C8.31806 13.8999 7.33078 14.057 6.36593 14.3038C6.34349 14.2365 6.32105 14.1916 6.29861 14.1243C7.42053 13.8999 8.45269 13.496 9.35023 13.0697V13.8775H9.37267ZM4.72793 14.2814C5.01963 14.2814 5.31133 14.2589 5.60302 14.2365C5.62546 14.3263 5.67034 14.416 5.69278 14.5282C5.04207 14.7526 4.43623 15.0219 3.89771 15.3584C3.5387 14.9545 3.247 14.5282 2.97774 14.0794C3.58357 14.2141 4.16697 14.2814 4.72793 14.2814Z" fill="#4D4D4D" />
      <path d="M21.6073 3.71906C21.4718 3.81874 20.5915 4.41462 19.4179 5.18698L19.574 6.21134L19.8139 6.03496C19.8626 5.99928 19.9283 5.99744 19.978 6.03155C20.2537 6.22049 20.4387 6.47591 20.533 6.79796C20.5501 6.85607 20.5283 6.91866 20.4796 6.95434L19.7669 7.47798L20.1865 10.2315C20.2692 10.7747 20.0691 11.3228 19.6564 11.6827L19.5109 11.8097L17.4172 6.48701C16.1424 7.30394 14.8151 8.13008 13.8102 8.70003L13.8473 10.3387C13.8504 10.4771 13.793 10.6099 13.6902 10.7021L13.2583 11.0891L12.7501 9.25893C12.4101 9.41621 12.1923 9.47955 12.1454 9.41473C12.0984 9.34989 12.2249 9.16046 12.4774 8.8822L10.9024 7.83598L11.4001 7.53993C11.5184 7.4695 11.6616 7.45497 11.7915 7.5002L13.3293 8.03604C14.1749 7.24592 15.361 6.2251 16.5224 5.25162L12.13 1.61816L12.2946 1.51723C12.7609 1.23134 13.3403 1.20665 13.8283 1.45193L16.3031 2.69505L17.0158 2.17125C17.0645 2.13557 17.1301 2.13372 17.1799 2.16784C17.4555 2.35678 17.6406 2.6122 17.7348 2.93425C17.7519 2.99236 17.7302 3.05495 17.6815 3.09063L17.4415 3.26701L18.3622 3.72936C19.4509 2.83927 20.2829 2.17685 20.4185 2.07718C20.8691 1.74622 22.122 1.38857 22.4502 1.84188C22.7785 2.29535 22.0579 3.38794 21.6073 3.71906Z" fill="#4D4D4D" />
    </svg>
  )
}

export const TopBar_notification = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M15.9085 13.0946L15.9078 13.0942C15.5629 12.9201 15.2747 12.6503 15.0738 12.3183L15.0738 12.3183C14.873 11.9864 14.7665 11.6041 14.7655 11.2148L14.7655 11.2134L14.7655 8.66408V8.65871H14.7655C14.7772 7.56614 14.4343 6.50341 13.7949 5.64122L13.7949 5.64118C13.1559 4.77938 12.2589 4.16936 11.2504 3.90453L10.5613 3.72357C10.4479 3.75837 10.3288 3.77666 10.2074 3.77666C10.0939 3.77666 9.9824 3.76066 9.87564 3.73011L9.15706 3.90651C8.16323 4.15047 7.2741 4.73662 6.63589 5.57433C5.9976 6.41253 5.64903 7.45232 5.64975 8.52572V8.52606V11.2126V11.214C5.64869 11.6034 5.54249 11.9857 5.34164 12.3178C5.14073 12.6501 4.85246 12.9199 4.50751 13.0942L4.50706 13.0944C4.20948 13.2444 3.95571 13.4794 3.7766 13.7751L15.9085 13.0946ZM15.9085 13.0946C16.2063 13.2443 16.4603 13.4791 16.6394 13.7745C16.8185 14.0702 16.9152 14.4134 16.9167 14.7651C16.9159 15.2136 16.7437 15.6401 16.4434 15.9518L16.8034 16.2987L16.4434 15.9518C16.1434 16.2631 15.7406 16.4347 15.3248 16.4352H12.7373H12.3017L12.3017 16.4355H11.9986H8.41622H8.11359L8.11356 16.4352H7.67796L5.09098 16.4352C5.09084 16.4352 5.0907 16.4352 5.09057 16.4352C4.67493 16.4342 4.27279 16.2627 3.9731 15.9515L3.97308 15.9515M15.9085 13.0946L3.97308 15.9515M3.97308 15.9515C3.67305 15.64 3.50094 15.2141 3.5 14.7658M3.97308 15.9515L3.5 14.7658M3.5 14.7658C3.50139 14.4137 3.5977 14.0706 3.77659 13.7751L3.5 14.7658Z" stroke="#4D4D4D" />
    </svg>
  )
}

export const TopBarNotificationBG = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="7.5" fill="#FA3E3E" stroke="white" />
    </svg>
  )
}

export const TopBarDropdown = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="none">
      <path d="M5.52382 6.99934C5.71165 6.9943 5.89116 6.90898 6.02753 6.76001L10.7683 1.50842C10.9632 1.29076 11.0429 0.969935 10.9776 0.666172C10.9121 0.362431 10.7116 0.121866 10.451 0.0347304C10.1905 -0.052425 9.90958 0.027099 9.71355 0.243536L5.5 4.9137L1.28646 0.243535C1.09042 0.0270983 0.809466 -0.052422 0.549027 0.0347295C0.288443 0.121885 0.0879179 0.362434 0.0224272 0.666171C-0.0429177 0.969911 0.0368448 1.29073 0.231688 1.50842L4.97248 6.76001C5.12076 6.92226 5.31973 7.0085 5.52382 6.99934Z" fill="#A0A0A0" />
    </svg>
  )
}

export const Sort = (color) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    // style={{rotate: "180deg"}}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5624 13.2467V2.67802C14.5624 2.30173 14.2588 2 13.8843 2C13.5072 2 13.2062 2.30356 13.2062 2.67802V13.2501L12.9235 12.9674C12.6568 12.7008 12.2294 12.7027 11.9646 12.9675C11.6979 13.2342 11.6997 13.6617 11.9644 13.9265L13.4031 15.3652C13.551 15.513 13.7484 15.5783 13.94 15.5619C14.0939 15.5488 14.2441 15.4831 14.3621 15.3652L15.8007 13.9265C16.0674 13.6598 16.0655 13.2324 15.8006 12.9675C15.534 12.7008 15.1065 12.7026 14.8417 12.9674L14.5624 13.2467ZM1 2.67812C1 2.30361 1.30442 2 1.67528 2H10.4965C10.8695 2 11.1718 2.30099 11.1718 2.67812C11.1718 3.05264 10.8674 3.35624 10.4965 3.35624H1.67528C1.30233 3.35624 1 3.05525 1 2.67812ZM1 6.74685C1 6.37233 1.30345 6.06873 1.67711 6.06873H9.13847C9.51242 6.06873 9.81557 6.36972 9.81557 6.74685C9.81557 7.12136 9.51212 7.42497 9.13847 7.42497H1.67711C1.30315 7.42497 1 7.12397 1 6.74685ZM1 10.8156C1 10.4411 1.30165 10.1375 1.67512 10.1375H7.78421C8.15707 10.1375 8.45933 10.4384 8.45933 10.8156C8.45933 11.1901 8.15768 11.4937 7.78421 11.4937H1.67512C1.30226 11.4937 1 11.1927 1 10.8156ZM1 14.8843C1 14.5098 1.30329 14.2062 1.67611 14.2062H5.74886C6.12226 14.2062 6.42497 14.5072 6.42497 14.8843C6.42497 15.2588 6.12167 15.5624 5.74886 15.5624H1.67611C1.3027 15.5624 1 15.2614 1 14.8843Z"
        fill="#111827"
      />
    </svg>
  );
};

export const Order = (color) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8434)">
        <path
          d="M1.40625 2.375H2.40625C2.66444 2.375 2.875 2.58512 2.875 2.84375L4.65125 9.99694C4.15834 10.2157 3.8125 10.7081 3.8125 11.2812C3.8125 12.0567 4.44331 12.6875 5.21875 12.6875H5.77384C5.72131 12.8348 5.6875 12.9911 5.6875 13.1562C5.6875 13.9317 6.31831 14.5625 7.09375 14.5625C7.86919 14.5625 8.5 13.9317 8.5 13.1562C8.5 12.9911 8.46619 12.8348 8.41366 12.6875H11.3988C11.3463 12.8348 11.3125 12.9911 11.3125 13.1562C11.3125 13.9317 11.9433 14.5625 12.7188 14.5625C13.4942 14.5625 14.125 13.9317 14.125 13.1562C14.125 12.3808 13.4942 11.75 12.7188 11.75H5.21875C4.96056 11.75 4.75 11.5399 4.75 11.2812C4.75 11.0226 4.96056 10.8125 5.21875 10.8125H13.8567L16 3.3125H3.97272L3.77038 2.50456L3.76672 2.50547C3.61428 1.89384 3.06447 1.4375 2.40625 1.4375H1.40625C0.630813 1.4375 0 2.06831 0 2.84375H0.9375C0.9375 2.58512 1.14806 2.375 1.40625 2.375ZM7.5625 13.1562C7.5625 13.4149 7.35194 13.625 7.09375 13.625C6.83556 13.625 6.625 13.4149 6.625 13.1562C6.625 12.8976 6.83556 12.6875 7.09375 12.6875C7.35194 12.6875 7.5625 12.8976 7.5625 13.1562ZM13.1875 13.1562C13.1875 13.4149 12.9769 13.625 12.7188 13.625C12.4606 13.625 12.25 13.4149 12.25 13.1562C12.25 12.8976 12.4606 12.6875 12.7188 12.6875C12.9769 12.6875 13.1875 12.8976 13.1875 13.1562ZM8.03125 6.86841L8.96875 7.80591L11.3125 5.46216L11.9753 6.125L8.96875 9.13159L7.36841 7.53125L8.03125 6.86841Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_8434">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrderPlaceEdit = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" >
      <path d="M16.8693 6.2915L13.7085 3.13101C13.5339 2.95633 13.251 2.95633 13.0765 3.13101L11.1704 5.0371C11.17 5.03728 11.1696 5.03746 11.1695 5.03781C11.1693 5.03817 11.1689 5.03835 11.1688 5.03871L3.93164 12.2756C3.86942 12.3378 3.82687 12.4169 3.80952 12.5031L3.00888 16.4645C2.9792 16.6113 3.02497 16.7631 3.13099 16.8691C3.21574 16.9537 3.32963 17 3.4471 17C3.47661 17 3.50629 16.9971 3.53561 16.9911L7.49683 16.1903C7.58301 16.1729 7.66221 16.1305 7.72426 16.0681L16.8691 6.92352C16.953 6.83967 17 6.72614 17 6.60742C17 6.4887 16.9532 6.37535 16.8693 6.2915ZM8.67259 13.8558L6.14406 11.3273L11.4858 5.98594L14.0141 8.5144L8.67259 13.8558ZM7.18751 15.3408L4.01836 15.9814L4.6588 12.8122L5.51184 11.9592L8.04055 14.488L7.18751 15.3408ZM14.6462 7.88238L12.1178 5.35392L13.3926 4.07914L15.9213 6.6076L14.6462 7.88238Z" fill="#707070" />
    </svg>
  )
}

export const OrderPlaceDelete = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.01301 12.5096V7.82284C7.01494 7.72159 7.05572 7.62515 7.12659 7.55424C7.19746 7.48333 7.29276 7.44361 7.39203 7.44361C7.49129 7.44361 7.58659 7.48333 7.65746 7.55424C7.72833 7.62515 7.76911 7.72159 7.77104 7.82284V12.5096C7.77202 12.561 7.76295 12.6121 7.74434 12.6599C7.72573 12.7077 7.69797 12.7512 7.66268 12.7879C7.62739 12.8246 7.58527 12.8538 7.5388 12.8737C7.49233 12.8936 7.44243 12.9039 7.39203 12.9039C7.34162 12.9039 7.29172 12.8936 7.24525 12.8737C7.19878 12.8538 7.15667 12.8246 7.12137 12.7879C7.08608 12.7512 7.05832 12.7077 7.03971 12.6599C7.02111 12.6121 7.01203 12.561 7.01301 12.5096ZM12.2291 12.5096V7.82284C12.2291 7.72026 12.269 7.62189 12.3401 7.54936C12.4112 7.47683 12.5076 7.43608 12.6082 7.43608C12.7087 7.43608 12.8052 7.47683 12.8762 7.54936C12.9473 7.62189 12.9873 7.72026 12.9873 7.82284V12.5096C12.9873 12.6121 12.9473 12.7105 12.8762 12.7831C12.8052 12.8556 12.7087 12.8963 12.6082 12.8963C12.5076 12.8963 12.4112 12.8556 12.3401 12.7831C12.269 12.7105 12.2291 12.6121 12.2291 12.5096ZM9.62106 13.1769V7.15565C9.62007 7.10424 9.62915 7.05314 9.64776 7.00535C9.66637 6.95756 9.69413 6.91403 9.72942 6.87732C9.76471 6.8406 9.80683 6.81144 9.8533 6.79153C9.89977 6.77162 9.94967 6.76136 10.0001 6.76136C10.0505 6.76136 10.1004 6.77162 10.1468 6.79153C10.1933 6.81144 10.2354 6.8406 10.2707 6.87732C10.306 6.91403 10.3338 6.95756 10.3524 7.00535C10.371 7.05314 10.3801 7.10424 10.3791 7.15565V13.1769C10.3801 13.2283 10.371 13.2794 10.3524 13.3272C10.3338 13.375 10.306 13.4185 10.2707 13.4552C10.2354 13.492 10.1933 13.5211 10.1468 13.541C10.1004 13.5609 10.0505 13.5712 10.0001 13.5712C9.94967 13.5712 9.89977 13.5609 9.8533 13.541C9.80683 13.5211 9.76471 13.492 9.72942 13.4552C9.69413 13.4185 9.66637 13.375 9.64776 13.3272C9.62915 13.2794 9.62007 13.2283 9.62106 13.1769ZM14.3271 13.8476V5.51005H5.6729V13.8476C5.67332 14.2661 5.83642 14.6674 6.12642 14.9634C6.41642 15.2594 6.80966 15.426 7.21988 15.4266H12.7803C13.1905 15.426 13.5837 15.2594 13.8736 14.9634C14.1636 14.6674 14.3267 14.2661 14.3271 13.8476ZM8.10916 4.33467C8.10935 4.18589 8.16735 4.04325 8.27046 3.93804C8.37356 3.83282 8.51335 3.77361 8.65918 3.77337H11.3408C11.4867 3.77361 11.6265 3.83282 11.7296 3.93803C11.8327 4.04324 11.8908 4.18587 11.891 4.33467V4.73653H8.10916V4.33467ZM15.6209 4.73653H12.6492V4.33467C12.6488 3.98081 12.5108 3.64156 12.2656 3.39134C12.0203 3.14113 11.6878 3.00039 11.341 3H8.65918C8.31234 3.00039 7.97982 3.14113 7.73456 3.39134C7.48931 3.64156 7.35136 3.98081 7.35098 4.33467V4.73653H4.37909C4.27855 4.73653 4.18213 4.77728 4.11103 4.84981C4.03994 4.92234 4 5.02072 4 5.12329C4 5.22587 4.03994 5.32424 4.11103 5.39677C4.18213 5.46931 4.27855 5.51005 4.37909 5.51005H4.91415V13.8476C4.91484 14.4713 5.15798 15.0692 5.59024 15.5102C6.0225 15.9512 6.60857 16.1993 7.21988 16.2H12.7803C13.3915 16.1993 13.9776 15.9512 14.4098 15.5102C14.842 15.0692 15.0851 14.4713 15.0857 13.8476V5.51005H15.6209C15.7215 5.51005 15.8179 5.46931 15.889 5.39677C15.9601 5.32424 16 5.22587 16 5.12329C16 5.02072 15.9601 4.92234 15.889 4.84981C15.8179 4.77728 15.7215 4.73653 15.6209 4.73653Z" fill="#707070" stroke="#707070" stroke-width="0.2" />
    </svg>
  )
}

export const OrderPlaceUserIcon = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0002 15.7889C15.0002 14.6023 14.5289 13.4643 13.6899 12.6253C12.8509 11.7863 11.7129 11.3149 10.5262 11.3149H9.47351C8.28685 11.3149 7.14888 11.7863 6.30987 12.6253C5.47086 13.4643 4.99951 14.6023 4.99951 15.7889V16.3153C4.99951 16.7514 5.35296 17.1048 5.78904 17.1048H14.2107C14.6468 17.1048 15.0002 16.7514 15.0002 16.3153C15.0002 16.164 15.0002 15.9858 15.0002 15.7889ZM14.4739 15.7889V16.3153C14.4739 16.4606 14.356 16.5785 14.2107 16.5785H5.78904C5.64377 16.5785 5.52586 16.4606 5.52586 16.3153V15.7889C5.52586 14.742 5.94169 13.7377 6.682 12.9974C7.42232 12.2571 8.4266 11.8413 9.47351 11.8413H10.5262C11.5731 11.8413 12.5774 12.2571 13.3177 12.9974C14.058 13.7377 14.4739 14.742 14.4739 15.7889Z" fill="#121212" stroke="#121212" stroke-width="0.5" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99943 3.99854C8.40169 3.99854 7.10449 5.29573 7.10449 6.89348C7.10449 8.49122 8.40169 9.78842 9.99943 9.78842C11.5972 9.78842 12.8944 8.49122 12.8944 6.89348C12.8944 5.29573 11.5972 3.99854 9.99943 3.99854ZM9.99943 4.52489C11.3066 4.52489 12.368 5.58628 12.368 6.89348C12.368 8.20068 11.3066 9.26207 9.99943 9.26207C8.69224 9.26207 7.63085 8.20068 7.63085 6.89348C7.63085 5.58628 8.69224 4.52489 9.99943 4.52489Z" fill="#121212" stroke="#121212" stroke-width="0.5" />
    </svg>
  )
}

export const OrderPlacePhoneIcon = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M13.3067 16.6655C11.4222 16.6655 9.32901 15.591 7.28488 13.5467C4.7788 11.0405 3.73026 8.46057 4.33246 6.28233C4.42027 5.9647 4.589 5.66719 4.82043 5.42202C5.35283 4.85817 5.96478 4.44354 6.59013 4.22317C6.94671 4.09733 7.33789 4.18083 7.61083 4.44133C8.16677 4.97141 8.61422 5.54551 8.97874 6.19636C9.08951 6.39258 9.19378 6.59892 9.28816 6.80903C9.44017 7.14731 9.391 7.53987 9.15982 7.83374C8.86211 8.21202 8.51054 8.61276 8.08507 9.05896C7.94731 9.20336 7.91368 9.42126 8.00129 9.60124C8.31735 10.2505 8.78776 10.8971 9.36172 11.4711C9.93562 12.0449 10.5821 12.5154 11.2315 12.8316C11.4109 12.919 11.6283 12.8854 11.7723 12.748C12.2185 12.3223 12.6193 11.9706 12.9976 11.673C13.2916 11.4416 13.6847 11.3922 14.0235 11.5447C14.2327 11.6387 14.4391 11.7429 14.6367 11.8544C15.2876 12.2192 15.8615 12.6667 16.3911 13.2222C16.6511 13.4949 16.7346 13.8857 16.6091 14.2419C16.3887 14.867 15.9742 15.4789 15.4104 16.0113C15.1653 16.2428 14.8678 16.4117 14.5498 16.4996C14.1482 16.6106 13.7327 16.6655 13.3067 16.6655ZM6.92362 4.6978C6.87152 4.6978 6.81876 4.70663 6.76757 4.72468C6.2219 4.917 5.68268 5.28437 5.20823 5.78692C5.03612 5.96911 4.91091 6.18935 4.84606 6.42387C4.29707 8.40966 5.29715 10.8059 7.66202 13.1709C10.0266 15.5358 12.4221 16.5358 14.4076 15.9869C14.6419 15.9221 14.8621 15.7969 15.0442 15.625C15.5467 15.1503 15.914 14.611 16.1064 14.0652C16.1651 13.8986 16.1263 13.7161 16.005 13.5889C15.5125 13.0721 14.9794 12.6564 14.3753 12.3179L14.3746 12.3175C14.191 12.214 13.9993 12.1171 13.8047 12.0297C13.6478 11.9592 13.465 11.9826 13.3275 12.0908C12.9625 12.3779 12.5743 12.7185 12.1405 13.1323C11.8361 13.423 11.3768 13.494 10.9978 13.3097C10.296 12.9679 9.59979 12.462 8.98459 11.8469C8.36932 11.2315 7.86359 10.5354 7.52204 9.83369C7.33776 9.45502 7.40892 8.99636 7.69916 8.69211C8.11291 8.25838 8.45362 7.8701 8.7408 7.5052C8.84923 7.36742 8.87265 7.18406 8.80201 7.02668C8.7142 6.83137 8.61734 6.63957 8.51411 6.45673C8.17542 5.85198 7.75971 5.31891 7.24273 4.82597C7.15492 4.74221 7.0407 4.6978 6.92362 4.6978Z" fill="#121212" stroke="#121212" stroke-width="0.4" />
    </svg>
  )
}

export const OrderPlaceEmailIcon = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4646 12.5553C16.4646 13.9064 15.3655 15.0038 14.0161 15.0038H5.98309C4.63369 15.0038 3.53459 13.9064 3.53459 12.5553V7.444C3.53459 6.99306 3.65806 6.56953 3.87238 6.20603L7.792 10.1257C8.37841 10.7138 9.16369 11.0378 10.0004 11.0378C10.8355 11.0378 11.6208 10.7138 12.2072 10.1257L16.1268 6.20603C16.3411 6.56953 16.4646 6.99303 16.4646 7.444V12.5553H16.4646ZM14.0161 4.99553H5.98309C5.42584 4.99553 4.91144 5.18412 4.49994 5.49791L8.459 9.45869C8.86881 9.86675 9.41575 10.0931 10.0004 10.0931C10.5834 10.0931 11.1304 9.86675 11.5402 9.45869L15.4992 5.49791C15.0878 5.18412 14.5734 4.99553 14.0161 4.99553ZM14.0161 4.05078H5.98309C4.11244 4.05078 2.58984 5.57337 2.58984 7.44403V12.5553C2.58984 14.4277 4.11244 15.9486 5.98309 15.9486H14.0161C15.8868 15.9486 17.4093 14.4277 17.4093 12.5553V7.444C17.4093 5.57334 15.8868 4.05078 14.0161 4.05078Z" fill="#121212" />
    </svg>
  )
}

export const OrderPlaceLocationIcon = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10.0008 16.3843C9.89666 16.3843 9.79251 16.3427 9.70918 16.2802C9.52171 16.0927 5.00146 11.8016 5.00146 8.05208C5.00146 5.23995 7.18868 3.05273 10.0008 3.05273C12.8129 3.05273 15.0002 5.23995 15.0002 8.05208C15.0002 11.8016 10.4799 16.0927 10.2924 16.2802C10.2091 16.3427 10.105 16.3843 10.0008 16.3843ZM10.0008 3.88596C7.66778 3.88596 5.83469 5.71905 5.83469 8.05208C5.83469 10.9267 9.02177 14.3846 10.0008 15.3845C10.9799 14.3846 14.1669 10.9267 14.1669 8.05208C14.1669 5.71905 12.3338 3.88596 10.0008 3.88596Z" fill="#121212" stroke="#121212" stroke-width="0.2" />
      <path d="M9.99929 9.7232C9.08257 9.7232 8.33252 8.97315 8.33252 8.05642C8.33252 7.1397 9.08257 6.38965 9.99929 6.38965C10.916 6.38965 11.6661 7.1397 11.6661 8.05642C11.6661 8.97315 10.916 9.7232 9.99929 9.7232ZM9.99929 7.22304C9.54093 7.22304 9.16591 7.59806 9.16591 8.05642C9.16591 8.51479 9.54093 8.88981 9.99929 8.88981C10.4577 8.88981 10.8327 8.51479 10.8327 8.05642C10.8327 7.59806 10.4577 7.22304 9.99929 7.22304Z" fill="#121212" stroke="#121212" stroke-width="0.2" />
    </svg>
  )
}

export const OrderPlaceAddIcon = (color)=> {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M17.7143 9.14297H10.8573V2.2858C10.8573 1.81276 10.4733 1.42871 10.0001 1.42871C9.52702 1.42871 9.14297 1.81276 9.14297 2.2858V9.14297H2.2858C1.81276 9.14297 1.42871 9.52702 1.42871 10.0001C1.42871 10.4733 1.81276 10.8573 2.2858 10.8573H9.14297V17.7143C9.14297 18.1875 9.52702 18.5716 10.0001 18.5716C10.4733 18.5716 10.8573 18.1875 10.8573 17.7143V10.8573H17.7143C18.1875 10.8573 18.5716 10.4733 18.5716 10.0001C18.5716 9.52702 18.1875 9.14297 17.7143 9.14297Z" fill="#9CA3AF" />
    </svg>
  )
}

export const Download = (color) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8503)">
        <g clipPath="url(#clip1_3304_8503)">
          <path
            d="M14.0191 10.9922C13.4427 10.9922 12.9754 11.4594 12.9754 12.0358V13.6625H3.02475V12.0358C3.02475 11.4595 2.5575 10.9922 1.98112 10.9922C1.40475 10.9922 0.9375 11.4594 0.9375 12.0358V14.7062C0.9375 15.2825 1.40475 15.7499 1.98112 15.7499H14.0192C14.5955 15.7499 15.0628 15.2825 15.0628 14.7062V12.0358C15.0628 11.4594 14.5955 10.9922 14.0191 10.9922Z"
            fill="#1B3048"
            fillOpacity="1"
          />
          <path
            d="M7.6843 12.1032C7.85815 12.2769 8.14055 12.2769 8.31421 12.1032L11.9717 8.44573C12.0782 8.33917 12.1099 8.17911 12.0523 8.03948C11.9946 7.90042 11.8591 7.80977 11.7081 7.80977H9.99083V1.06252C9.99083 0.612453 9.62643 0.248047 9.17646 0.248047H6.82261C6.37268 0.248047 6.00824 0.612422 6.00824 1.06252V7.80977H4.29033C4.13949 7.80977 4.00399 7.90039 3.94636 8.03948C3.88874 8.17911 3.92043 8.33917 4.02683 8.44573L7.6843 12.1032Z"
            fill="#1B3048"
            fillOpacity="1"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3304_8503">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_3304_8503">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Edit = (color) => {
  return (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="10" height="10" viewBox="0 0 528.899 528.899"
    >
      <g>
        <path d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
		c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
		C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
		L27.473,390.597L0.3,512.69z"/>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
    </svg>
  )
}

export const FilterExpand = (color) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.09091 11.5767V0.786931H6.5483V11.5767H5.09091ZM0.420455 6.90625V5.45739H11.2188V6.90625H0.420455Z" fill="#4D4D4D" fill-opacity="0.8" />
    </svg>
  )
}
export const FilterShrink = (color) => {
  return (
    <svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.82386 0.117897V1.66903H0.957386V0.117897H8.82386Z" fill="#717171" />
    </svg>
  )
}

export const Search = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M15.8104 14.7887L13.1976 12.203C15.1805 9.73378 14.9939 6.09983 12.731 3.84027C11.5413 2.65225 9.97828 2 8.29865 2C6.61901 2 5.03268 2.65225 3.84294 3.84027C2.65319 5.02829 2 6.58902 2 8.28952C2 9.99002 2.65319 11.5507 3.84294 12.7388C5.03268 13.9035 6.59568 14.579 8.29865 14.579C9.72167 14.579 11.1214 14.0899 12.2178 13.2047L14.8072 15.7903C14.9472 15.9301 15.1105 16 15.2971 16C15.4838 16 15.6704 15.9301 15.787 15.7903C16.067 15.5108 16.067 15.0682 15.8104 14.7887ZM13.1976 8.28952C13.1976 9.59401 12.6844 10.8286 11.7512 11.7371C10.8181 12.6456 9.60503 13.1814 8.29865 13.1814C6.99226 13.1814 5.75586 12.6689 4.84605 11.7371C3.93625 10.8053 3.3997 9.59401 3.3997 8.28952C3.3997 6.98503 3.91292 5.75042 4.84605 4.84193C5.77919 3.93344 6.96893 3.39767 8.29865 3.39767C9.60503 3.39767 10.8414 3.91015 11.7512 4.84193C12.661 5.77371 13.1976 6.96173 13.1976 8.28952Z" fill="white" stroke="white" stroke-width="0.5" />
    </svg>
  )
}
export const Prev = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40" fill="none">
      <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" fill="white" stroke="#DDDDDD" />
      <path d="M18.3811 15.9531L14.3345 19.9998L18.3811 24.0465" stroke="#121212" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M25.6668 20H14.4468" stroke="#121212" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
export const Next = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40" fill="none">
      <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="#DDDDDD" />
      <path d="M21.6189 15.9531L25.6655 19.9998L21.6189 24.0465" stroke="#121212" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14.3332 20H25.5532" stroke="#121212" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
export const Profile = (color) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8512)">
        <path
          d="M7.86709 0.380859C5.86834 0.380859 4.24805 2.00116 4.24805 3.99991C4.24805 5.99865 5.86834 7.61895 7.86709 7.61895C9.8658 7.61895 11.4861 5.99865 11.4861 3.99991C11.4861 2.00116 9.8658 0.380859 7.86709 0.380859Z"
          fill="#1B3048"
          fillOpacity="1"
        />
        <path
          d="M5.58194 8.76172C3.58319 8.76172 1.96289 10.382 1.96289 12.3808C1.96289 14.3795 3.58319 15.9998 5.58194 15.9998H10.1534C12.1521 15.9998 13.7724 14.3795 13.7724 12.3808C13.7724 10.382 12.1521 8.76172 10.1534 8.76172H5.58194Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_8512">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Invoice = (color) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8466)">
        <path d="M10 0V4H14L10 0Z" fill="#1B3048" fillOpacity="0.7" />
        <path
          d="M10 5C9.449 5 9 4.551 9 4V0H3C2.449 0 2 0.449 2 1V15C2 15.552 2.449 16 3 16H13C13.552 16 14 15.552 14 15V5H10ZM5.5 3.062V2.5C5.5 2.224 5.724 2 6 2C6.276 2 6.5 2.224 6.5 2.5V3.063C6.813 3.134 7.105 3.266 7.346 3.462C7.561 3.636 7.593 3.951 7.418 4.165C7.243 4.38 6.928 4.411 6.715 4.237C6.526 4.084 6.272 4 6 4C5.458 4 5 4.343 5 4.75C5 5.157 5.458 5.5 6 5.5C7.103 5.5 8 6.285 8 7.25C8 8.063 7.36 8.742 6.5 8.938V9.5C6.5 9.776 6.276 10 6 10C5.724 10 5.5 9.776 5.5 9.5V8.937C5.187 8.866 4.895 8.734 4.654 8.538C4.439 8.363 4.407 8.048 4.582 7.834C4.757 7.618 5.071 7.588 5.285 7.762C5.474 7.916 5.728 8 6 8C6.542 8 7 7.657 7 7.25C7 6.843 6.542 6.5 6 6.5C4.897 6.5 4 5.715 4 4.75C4 3.937 4.64 3.258 5.5 3.062ZM11.5 14H4.5C4.224 14 4 13.776 4 13.5C4 13.224 4.224 13 4.5 13H11.5C11.776 13 12 13.224 12 13.5C12 13.776 11.776 14 11.5 14ZM11.5 12H4.5C4.224 12 4 11.776 4 11.5C4 11.224 4.224 11 4.5 11H11.5C11.776 11 12 11.224 12 11.5C12 11.776 11.776 12 11.5 12ZM11.5 10H9.5C9.224 10 9 9.776 9 9.5C9 9.224 9.224 9 9.5 9H11.5C11.776 9 12 9.224 12 9.5C12 9.776 11.776 10 11.5 10ZM11.5 8H9.5C9.224 8 9 7.776 9 7.5C9 7.224 9.224 7 9.5 7H11.5C11.776 7 12 7.223 12 7.5C12 7.776 11.776 8 11.5 8Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_8466">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Wallet = (color) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8478)">
        <g clipPath="url(#clip1_3304_8478)">
          <path
            d="M13 11.9993C11.346 11.9993 10 10.6533 10 8.99935C10 7.34535 11.346 5.99935 13 5.99935H14.6667V4.66602C14.6667 3.93068 14.0687 3.33268 13.3333 3.33268H12.6667V1.99935C12.6667 1.26402 12.0687 0.666016 11.3333 0.666016H2C1.01133 0.666016 0.194 1.38868 0.034 2.33202C0.0193333 2.38668 0 2.44002 0 2.49935V12.666C0 13.7687 0.897333 14.666 2 14.666H13.3333C14.0687 14.666 14.6667 14.068 14.6667 13.3327V11.9993H13ZM1.33333 2.66602C1.33333 2.29868 1.632 1.99935 2 1.99935H11.3333V3.33268H2C1.632 3.33268 1.33333 3.03335 1.33333 2.66602Z"
            fill="#1B3048"
            fillOpacity="1"
          />
          <path
            d="M15.5 7H13C11.8973 7 11 7.89733 11 9C11 10.1027 11.8973 11 13 11H15.5C15.776 11 16 10.776 16 10.5V7.5C16 7.224 15.776 7 15.5 7ZM13 9.66667C12.632 9.66667 12.3333 9.368 12.3333 9C12.3333 8.632 12.632 8.33333 13 8.33333C13.368 8.33333 13.6667 8.632 13.6667 9C13.6667 9.368 13.368 9.66667 13 9.66667Z"
            fill="#1B3048"
            fillOpacity="1"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3304_8478">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_3304_8478">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddressNook = (color) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8486)">
        <g clipPath="url(#clip1_3304_8486)">
          <path
            d="M15.1904 6.57629L13.0849 4.80184V2.2819C13.0849 2.02179 12.8741 1.81097 12.614 1.81097H11.1215C10.8614 1.81097 10.6505 2.02179 10.6505 2.2819V2.74903L8.41065 0.861525C8.17331 0.642512 7.81423 0.642512 7.58297 0.861525L0.80931 6.57629C0.62673 6.74663 0.565883 7.00839 0.657191 7.24565C0.7485 7.47699 0.973597 7.62914 1.22322 7.62914H2.20294V14.6948C2.20294 15.0296 2.47687 15.3034 2.81156 15.3034H13.1881C13.5228 15.3034 13.7967 15.0296 13.7967 14.6948V7.62914H14.7765C15.026 7.62914 15.2512 7.47699 15.3425 7.23957C15.4338 7.00839 15.3729 6.74663 15.1904 6.57629ZM8.45936 13.0909C8.19761 13.4499 7.66207 13.4499 7.39431 13.0909C6.55446 11.9346 5.00864 9.65844 5.00864 8.48991C5.00864 6.88327 6.31708 5.57472 7.92984 5.57472C9.54263 5.57472 10.8511 6.88327 10.8511 8.48991C10.8511 9.65844 9.30525 11.9346 8.45936 13.0909Z"
            fill="#1B3048"
            fillOpacity="1"
          />
          <path
            d="M7.93012 9.36024C8.60238 9.36024 9.14735 8.81527 9.14735 8.14301C9.14735 7.47075 8.60238 6.92578 7.93012 6.92578C7.25786 6.92578 6.71289 7.47075 6.71289 8.14301C6.71289 8.81527 7.25786 9.36024 7.93012 9.36024Z"
            fill="#1B3048"
            fillOpacity="1"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3304_8486">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_3304_8486">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ActionNeeded = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8424)">
        <g clipPath="url(#clip1_3304_8424)">
          <path
            d="M8.01038 5.50781C7.16467 5.50781 6.47656 6.19592 6.47656 7.04163C6.47656 7.88733 7.16467 8.57532 8.01038 8.57532C8.85608 8.57532 9.54407 7.88733 9.54407 7.04163C9.54407 6.19592 8.85608 5.50781 8.01038 5.50781Z"
            fill="#1B3048"
            fillOpacity="1"
          />
          <path
            d="M9.35999 12.0134C8.92969 12.1304 8.47717 12.1929 8.01025 12.1929C5.17004 12.1929 2.85938 9.88184 2.85938 7.0415C2.85938 4.20129 5.17004 1.89063 8.01025 1.89063C10.8506 1.89063 13.1616 4.20129 13.1616 7.0415C13.1616 8.36536 12.6597 9.57373 11.8359 10.4872L13.8225 11.0194C14.6216 9.85706 15.0522 8.48267 15.0522 7.04175C15.0522 5.16077 14.3197 3.39246 12.9897 2.0625C11.6597 0.732422 9.89136 0 8.0105 0C6.12952 0 4.36121 0.732422 3.03125 2.0625C1.70117 3.39246 0.96875 5.16077 0.96875 7.04175C0.96875 8.92261 1.70117 10.6909 3.03125 12.021C4.36121 13.351 6.12952 14.0835 8.0105 14.0835C8.64038 14.0835 9.25745 14.0007 9.84985 13.8413L9.35999 12.0134Z"
            fill="#1B3048"
            fillOpacity="1"
          />
          <path
            d="M12.2241 7.0415C12.2241 4.71838 10.3337 2.82812 8.01025 2.82812C5.68713 2.82812 3.79688 4.71838 3.79688 7.0415C3.79688 9.36499 5.68713 11.2554 8.01025 11.2554C8.39307 11.2554 8.7644 11.2041 9.11719 11.1078L8.72778 9.65442L10.7891 10.2065C11.6685 9.43372 12.2241 8.30127 12.2241 7.0415ZM8.0105 9.51294C6.64783 9.51294 5.53918 8.4043 5.53918 7.04175C5.53918 5.67908 6.64783 4.57043 8.0105 4.57043C9.37317 4.57043 10.4817 5.67908 10.4817 7.04175C10.4817 8.4043 9.37305 9.51294 8.0105 9.51294Z"
            fill="#1B3048"
            fillOpacity="1"
          />
          <path
            d="M12.1338 14.416L13.7179 16.0001L15.0745 14.6436L13.4904 13.0594L14.4044 12.1458L10.0547 10.9805L11.2201 15.3298L12.1338 14.416Z"
            fill="#1B3048"
            fillOpacity="1"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3304_8424">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_3304_8424">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ];
};

export const SignOut = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8512)">
        <path
          d="M6.53065 13.5503C6.5102 13.4959 6.50316 13.4496 6.51009 13.4122C6.51699 13.375 6.49323 13.3442 6.43872 13.3205C6.38422 13.2968 6.35702 13.2779 6.35702 13.2645C6.35702 13.2509 6.31795 13.2406 6.23965 13.2339C6.16138 13.2271 6.12231 13.2236 6.12231 13.2236H5.98972H5.87749H2.93871C2.48974 13.2236 2.10535 13.0639 1.78559 12.744C1.46589 12.4242 1.30606 12.0399 1.30606 11.591V4.40732C1.30606 3.95835 1.46585 3.5741 1.78559 3.25437C2.10535 2.9346 2.48974 2.77466 2.93871 2.77466H6.20398C6.29244 2.77466 6.36199 2.75272 6.41313 2.7084C6.46406 2.66419 6.49801 2.59782 6.5151 2.5094C6.53211 2.42098 6.54237 2.34113 6.5458 2.26969C6.54916 2.19832 6.54751 2.10811 6.54065 1.99928C6.5339 1.89049 6.5305 1.82247 6.5305 1.79513C6.5305 1.70671 6.49816 1.63033 6.43357 1.56557C6.36892 1.50109 6.29244 1.46875 6.20401 1.46875H2.93871C2.12926 1.46875 1.43705 1.75617 0.862163 2.33098C0.287423 2.9058 0 3.59791 0 4.40742V11.591C0 12.4005 0.287423 13.0927 0.862163 13.6673C1.43705 14.2424 2.12926 14.5299 2.93871 14.5299H6.20412C6.29258 14.5299 6.36216 14.5076 6.41327 14.4636C6.4642 14.4193 6.49816 14.353 6.51524 14.2645C6.53225 14.1762 6.54251 14.0959 6.54594 14.0248C6.5493 13.9533 6.54766 13.8633 6.5408 13.7545C6.53397 13.6455 6.53065 13.5776 6.53065 13.5503Z"
          fill="#1B3048"
          fillOpacity="1"
        />
        <path
          d="M15.8058 7.53992L10.2548 1.98878C10.1256 1.85968 9.97252 1.79492 9.79564 1.79492C9.61876 1.79492 9.46565 1.85968 9.33634 1.98878C9.20707 2.11805 9.14248 2.27127 9.14248 2.44804V5.38682H4.57109C4.3941 5.38682 4.2411 5.45158 4.11182 5.58068C3.98255 5.70995 3.91797 5.86306 3.91797 6.03994V9.95836C3.91797 10.1352 3.98255 10.2883 4.11182 10.4175C4.24124 10.5465 4.39421 10.6115 4.57109 10.6115H9.14252V13.5502C9.14252 13.727 9.2071 13.8802 9.33638 14.0094C9.46565 14.1387 9.61876 14.2034 9.79567 14.2034C9.97252 14.2034 10.1256 14.1387 10.2548 14.0094L15.8058 8.45849C15.935 8.32911 15.9997 8.17621 15.9997 7.99929C15.9997 7.82245 15.935 7.6692 15.8058 7.53992Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_8512">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ];
};
export const Tutorial = (color) => {
  return [
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3304_8495)">
        <path
          d="M15 13.5C15 13.7765 14.776 14 14.5 14H4.908C4.701 14.5805 4.151 15 3.5 15C2.849 15 2.299 14.5805 2.092 14H1.5C1.224 14 1 13.7765 1 13.5C1 13.2235 1.224 13 1.5 13H2.092C2.299 12.4195 2.849 12 3.5 12C4.151 12 4.701 12.4195 4.908 13H14.5C14.776 13 15 13.2235 15 13.5ZM7 7.5275L9.4695 6L6.9975 4.471L7 7.5275ZM15 2.5V9.5C15 10.327 14.327 11 13.5 11H2.5C1.673 11 1 10.327 1 9.5V2.5C1 1.673 1.673 1 2.5 1H13.5C14.327 1 15 1.673 15 2.5ZM10.469 6C10.469 5.651 10.292 5.3335 9.995 5.1495L7.5255 3.622C7.218 3.4315 6.8295 3.4225 6.513 3.599C6.1965 3.7755 6 4.11 6 4.4725V7.5275C6 7.89 6.197 8.225 6.513 8.401C6.6645 8.4855 6.832 8.527 6.9995 8.527C7.1825 8.527 7.365 8.477 7.5255 8.378L9.995 6.85C10.2915 6.6665 10.4685 6.3485 10.4685 5.9995L10.469 6Z"
          fill="#1B3048"
          fillOpacity="1"
        />
      </g>
      <defs>
        <clipPath id="clip0_3304_8495">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ];
};
export const Product = (color) => {
  return [
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: "2px" }}
    >
      <g clipPath="url(#clip0_3304_8446)">
        <g clipPath="url(#clip1_3304_8446)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.46667 12.2698L1.06667 9.0285V12.4248C1.06667 12.6296 1.1808 12.8165 1.3616 12.9078L7.46667 16V12.2698ZM8.53333 12.2698V16L14.6384 12.9078C14.8192 12.8165 14.9333 12.6296 14.9333 12.4248V9.0285L8.53333 12.2698ZM7.46667 8.43697L0.00213331 4.65653L0 7.02214C0 7.22688 0.114133 7.41434 0.294933 7.50563L7.46667 11.1381V8.43697ZM15.9979 4.65653L8.53333 8.43697V11.1381L15.7051 7.50563C15.8859 7.41434 16 7.22688 16 7.02214L15.9979 4.65653ZM0.533333 3.71764L8 7.49915L15.4667 3.71764L8.2384 0.0571279C8.08853 -0.0190426 7.91147 -0.0190426 7.7616 0.0571279L0.533333 3.71764Z"
            fill="#1B3048"
            fillOpacity="0.7"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3304_8446">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_3304_8446">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ];
};
export const Transactions = (color) => {
  return [
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01953 10.9224V11.6629C7.01953 13.0311 7.97996 14.2204 9.24107 14.5633V16.1437H10.7221V14.566C11.2267 14.4321 11.6919 14.1622 12.0749 13.7733C12.6351 13.2044 12.9436 12.4593 12.9436 11.6755C12.9436 10.9276 12.63 10.2717 12.0113 9.72591C11.5325 9.30347 10.9252 8.98699 10.3379 8.68086L10.3238 8.67348C9.29345 8.13637 8.83377 7.75975 8.83377 6.94757C8.83377 6.34269 9.34869 5.85055 9.98158 5.85055C10.6145 5.85055 11.1294 6.34885 11.1294 6.96133V7.70184H12.6104V6.96133C12.6104 5.7857 11.8121 4.79103 10.7221 4.47492V2.81445H9.24107V4.4744C8.15105 4.7888 7.35275 5.77821 7.35275 6.94761C7.35275 8.79501 8.78409 9.54108 9.63931 9.98682L9.65341 9.9942C10.7751 10.5789 11.4626 10.9729 11.4626 11.6755C11.4626 12.4919 10.7844 13.1817 9.98158 13.1817C9.19262 13.1817 8.50055 12.472 8.50055 11.663V10.9225L7.01953 10.9224Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
      <path
        d="M10.0195 17.476C7.13698 17.476 4.55337 15.9708 3.13192 13.5513H5.68749V12.0703H0.503906V17.2539H1.98493V14.5117C2.65989 15.5892 3.54801 16.5233 4.6089 17.262C6.20137 18.3709 8.07236 18.9571 10.0195 18.9571C12.5499 18.9571 14.9241 17.9706 16.7049 16.1793C18.4822 14.3915 19.461 12.0118 19.461 9.47852H17.98C17.98 13.8884 14.4089 17.476 10.0195 17.476Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
      <path
        d="M18.017 1.70317V4.44533C17.342 3.36782 16.4539 2.43381 15.393 1.69508C13.8006 0.586147 11.9296 0 9.98246 0C7.45064 0 5.0704 0.985951 3.28013 2.77619C1.48986 4.56649 0.503906 6.94673 0.503906 9.47855H1.98493C1.98493 5.06869 5.57259 1.48102 9.98246 1.48102C12.865 1.48102 15.4486 2.98623 16.87 5.40572H14.3145V6.88675H19.498V1.70317H18.017Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
    </svg>,
  ];
};
export const RechargeRequests = (color) => {
  return [
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01953 10.9224V11.6629C7.01953 13.0311 7.97996 14.2204 9.24107 14.5633V16.1437H10.7221V14.566C11.2267 14.4321 11.6919 14.1622 12.0749 13.7733C12.6351 13.2044 12.9436 12.4593 12.9436 11.6755C12.9436 10.9276 12.63 10.2717 12.0113 9.72591C11.5325 9.30347 10.9252 8.98699 10.3379 8.68086L10.3238 8.67348C9.29345 8.13637 8.83377 7.75975 8.83377 6.94757C8.83377 6.34269 9.34869 5.85055 9.98158 5.85055C10.6145 5.85055 11.1294 6.34885 11.1294 6.96133V7.70184H12.6104V6.96133C12.6104 5.7857 11.8121 4.79103 10.7221 4.47492V2.81445H9.24107V4.4744C8.15105 4.7888 7.35275 5.77821 7.35275 6.94761C7.35275 8.79501 8.78409 9.54108 9.63931 9.98682L9.65341 9.9942C10.7751 10.5789 11.4626 10.9729 11.4626 11.6755C11.4626 12.4919 10.7844 13.1817 9.98158 13.1817C9.19262 13.1817 8.50055 12.472 8.50055 11.663V10.9225L7.01953 10.9224Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
      <path
        d="M10.0195 17.476C7.13698 17.476 4.55337 15.9708 3.13192 13.5513H5.68749V12.0703H0.503906V17.2539H1.98493V14.5117C2.65989 15.5892 3.54801 16.5233 4.6089 17.262C6.20137 18.3709 8.07236 18.9571 10.0195 18.9571C12.5499 18.9571 14.9241 17.9706 16.7049 16.1793C18.4822 14.3915 19.461 12.0118 19.461 9.47852H17.98C17.98 13.8884 14.4089 17.476 10.0195 17.476Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
      <path
        d="M18.017 1.70317V4.44533C17.342 3.36782 16.4539 2.43381 15.393 1.69508C13.8006 0.586147 11.9296 0 9.98246 0C7.45064 0 5.0704 0.985951 3.28013 2.77619C1.48986 4.56649 0.503906 6.94673 0.503906 9.47855H1.98493C1.98493 5.06869 5.57259 1.48102 9.98246 1.48102C12.865 1.48102 15.4486 2.98623 16.87 5.40572H14.3145V6.88675H19.498V1.70317H18.017Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
    </svg>,
  ];
};
export const BuyingInvoice = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.30863 2.36698C9.30863 2.47149 9.39366 2.55653 9.49817 2.55653H11.7962C11.9007 2.55653 11.9858 2.47149 11.9858 2.36698C11.9858 2.26248 11.9007 2.17744 11.7962 2.17744H9.49817C9.39366 2.17744 9.30863 2.26248 9.30863 2.36698ZM5.00408 13.0944C5.00408 13.1989 5.08912 13.2839 5.19362 13.2839H11.7962C11.9007 13.2839 11.9858 13.1989 11.9858 13.0944C11.9858 12.9899 11.9007 12.9048 11.7962 12.9048H5.19362C5.08912 12.9048 5.00408 12.9899 5.00408 13.0944ZM5.00408 11.3068C5.00408 11.4113 5.08912 11.4963 5.19362 11.4963H11.7962C11.9007 11.4963 11.9858 11.4113 11.9858 11.3068C11.9858 11.2023 11.9007 11.1172 11.7962 11.1172H5.19362C5.08912 11.1172 5.00408 11.2023 5.00408 11.3068ZM5.00408 9.51851C5.00408 9.62302 5.08912 9.70806 5.19362 9.70806H11.7962C11.9007 9.70806 11.9858 9.62302 11.9858 9.51851C11.9858 9.41401 11.9007 9.32897 11.7962 9.32897H5.19362C5.08912 9.32897 5.00408 9.41401 5.00408 9.51851ZM9.00408 7.73069C9.00408 7.83519 9.08912 7.92023 9.19362 7.92023H11.7962C11.9007 7.92023 11.9858 7.83519 11.9858 7.73069C11.9858 7.62618 11.9007 7.54114 11.7962 7.54114H9.19362C9.08912 7.54114 9.00408 7.62618 9.00408 7.73069ZM9.00408 5.94308C9.00408 6.04759 9.08912 6.13263 9.19362 6.13263H11.7962C11.9007 6.13263 11.9858 6.04759 11.9858 5.94308C11.9858 5.83858 11.9007 5.75354 11.7962 5.75354H9.19362C9.08912 5.75354 9.00408 5.83858 9.00408 5.94308ZM9.30863 4.15481C9.30863 4.25932 9.39366 4.34436 9.49817 4.34436H11.7962C11.9007 4.34436 11.9858 4.25932 11.9858 4.15481C11.9858 4.0503 11.9007 3.96526 11.7962 3.96526H9.49817C9.39366 3.96526 9.30863 4.0503 9.30863 4.15481ZM14.1735 3.74327V7.62372V16.673C14.1735 17.0382 14.0244 17.37 13.7834 17.6108C13.5435 17.851 13.2117 18 12.8467 18C12.4817 18 12.1496 17.8505 11.9083 17.6102C11.6682 17.3703 11.5192 17.0382 11.5192 16.673V15.172C11.5192 15.0675 11.4341 14.9825 11.3296 14.9825H3.02089V0.834722C3.02089 0.606012 3.11532 0.396996 3.2666 0.245717C3.41788 0.0944376 3.6269 0 3.85561 0H14.5436C14.3151 0.230723 14.1735 0.547604 14.1735 0.895144V3.74327ZM11.7765 18H1.3275C0.962503 18 0.630405 17.8505 0.384688 17.6052C0.145013 17.3611 0 17.0332 0 16.673V15.3616H11.1401V16.673C11.1401 17.1416 11.3321 17.5683 11.6411 17.8783C11.6841 17.9212 11.7293 17.9617 11.7765 18ZM15.4417 0C15.6968 0.00134272 15.919 0.101599 16.0801 0.262501C16.2422 0.424746 16.3426 0.648755 16.3426 0.895144V7.42925H14.5526V3.74327V0.895144C14.5526 0.648755 14.6531 0.424746 14.8157 0.262277C14.9749 0.102942 15.1942 0.003133 15.4417 0ZM5 5.98305V5.64972L5.75 5.64973V5.98307C5.75 6.34723 6.10046 6.66668 6.5 6.66668C6.90654 6.66668 7.25 6.35621 7.25 5.98871C7.25 5.67243 6.90185 5.49507 6.33381 5.23189L6.32667 5.22856C5.89359 5.02792 5.16874 4.69208 5.16874 3.86049C5.16874 3.3341 5.57301 2.88873 6.125 2.74721V2H6.875V2.74744C7.42699 2.88974 7.83126 3.33747 7.83126 3.86667V4.20001H7.08126V3.86667C7.08126 3.59097 6.8205 3.36667 6.5 3.36667C6.1795 3.36667 5.91874 3.5882 5.91874 3.86048C5.91874 4.22607 6.15153 4.39561 6.67333 4.63738L6.68046 4.6407L6.68084 4.64088C6.97812 4.77862 7.28548 4.92104 7.52785 5.11112C7.84116 5.35678 8 5.65204 8 5.9887C8 6.34153 7.84377 6.6769 7.56007 6.933C7.36614 7.10806 7.13052 7.22958 6.875 7.28982V8H6.125V7.2886C5.48637 7.13426 5 6.59894 5 5.98305Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
    </svg>,
  ];
};
export const ShipmentInvoice = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.0625 3.75V0.183106L12.9419 4.0625H9.375C9.20257 4.0625 9.0625 3.92227 9.0625 3.75ZM15.5029 12.0145L16.25 12.5891L16.2521 12.5904L16.2503 9.5H14.375V12.5891L15.1221 12.0145C15.2344 11.9281 15.3906 11.9281 15.5029 12.0145ZM13.75 9.5H12.1875C11.6705 9.5 11.25 9.92053 11.25 10.4375V11.375H13.75V9.5ZM18.4375 9.5H16.875V11.375H19.375V10.4375C19.375 9.92053 18.9545 9.5 18.4375 9.5ZM16.875 12H19.375V16.6875C19.375 17.2045 18.9545 17.625 18.4375 17.625H12.1875C11.6705 17.625 11.25 17.2045 11.25 16.6875V12H13.75V12.5503C13.75 12.765 13.8403 12.9792 14.0168 13.1014C14.2451 13.2595 14.5401 13.2507 14.7559 13.0844L15.3125 12.6564L15.8426 13.0643C16.0133 13.1956 16.2397 13.2519 16.444 13.1835C16.707 13.0956 16.875 12.8581 16.875 12.5891V12ZM14.6875 16.375C14.6875 16.2024 14.5476 16.0625 14.375 16.0625H12.5C12.3274 16.0625 12.1875 16.2024 12.1875 16.375C12.1875 16.5476 12.3274 16.6875 12.5 16.6875H14.375C14.5476 16.6875 14.6875 16.5476 14.6875 16.375ZM10.9455 17.625H1.5625C1.04553 17.625 0.625 17.2045 0.625 16.6875V0.9375C0.625 0.420531 1.04553 0 1.5625 0H8.4375V1.875H4.53125C3.92822 1.875 3.4375 2.36572 3.4375 2.96875C3.4375 3.57178 3.92822 4.0625 4.53125 4.0625H8.4951C8.62452 4.42547 8.96814 4.6875 9.375 4.6875H13.125V8.875H12.1875C11.326 8.875 10.625 9.57599 10.625 10.4375H5C4.82727 10.4375 4.6875 10.5774 4.6875 10.75C4.6875 10.9226 4.82727 11.0625 5 11.0625H10.625V12.625H5C4.82727 12.625 4.6875 12.7649 4.6875 12.9375C4.6875 13.1101 4.82727 13.25 5 13.25H10.625V14.8125H5C4.82727 14.8125 4.6875 14.9524 4.6875 15.125C4.6875 15.2976 4.82727 15.4375 5 15.4375H10.625V16.6875C10.625 17.0406 10.7472 17.363 10.9455 17.625ZM4.6875 7.5625C4.6875 7.73508 4.82727 7.875 5 7.875H11.25C11.4227 7.875 11.5625 7.73508 11.5625 7.5625C11.5625 7.38992 11.4227 7.25 11.25 7.25H5C4.82727 7.25 4.6875 7.38992 4.6875 7.5625ZM4.28345 14.2791C4.16138 14.157 3.96362 14.157 3.84155 14.2791L2.84882 15.2719L2.60437 14.9398C2.50183 14.8009 2.30652 14.7713 2.16736 14.8732C2.0285 14.9756 1.99859 15.1712 2.10083 15.3102L2.56073 15.9352C2.66735 16.0873 2.90498 16.1055 3.03345 15.9709L4.28345 14.7209C4.40552 14.5989 4.40552 14.4011 4.28345 14.2791ZM4.28345 12.0916C4.16138 11.9695 3.96362 11.9695 3.84155 12.0916L2.84882 13.0844L2.60437 12.7523C2.50183 12.6133 2.30652 12.5836 2.16736 12.6857C2.0285 12.7881 1.99859 12.9837 2.10083 13.1227L2.56073 13.7477C2.66735 13.8998 2.90498 13.918 3.03345 13.7834L4.28345 12.5334C4.40552 12.4114 4.40552 12.2136 4.28345 12.0916ZM4.28345 9.90405C4.16138 9.78198 3.96362 9.78198 3.84155 9.90405L2.84882 10.8969L2.60437 10.5648C2.50183 10.4261 2.30652 10.3965 2.16736 10.4982C2.0285 10.6006 1.99859 10.7962 2.10083 10.9352L2.56073 11.5602C2.66735 11.7123 2.90498 11.7305 3.03345 11.5959L4.28345 10.3459C4.40552 10.2239 4.40552 10.0261 4.28345 9.90405ZM4.28345 6.71655C4.16138 6.59448 3.96362 6.59448 3.84155 6.71655L2.84882 7.70944L2.60437 7.37726C2.50183 7.2384 2.30652 7.2088 2.16736 7.31073C2.0285 7.41312 1.99859 7.60873 2.10083 7.74774L2.56073 8.37274C2.66735 8.52476 2.90498 8.54305 3.03345 8.40845L4.28345 7.15845C4.40552 7.03638 4.40552 6.83862 4.28345 6.71655Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
    </svg>,
  ];
};
export const MyOrderIcon = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3360_5485)">
        <path
          d="M19.8614 5.51963C19.7493 5.38803 19.5856 5.31248 19.414 5.31248H4.73256L3.57315 1.05703C3.50335 0.801835 3.27217 0.625 3.0078 0.625H0.585935C0.262069 0.625 0 0.887069 0 1.21094C0 1.5348 0.262069 1.79687 0.585935 1.79687H2.56034C7.00626 18.0855 5.47287 12.4675 5.80459 13.6829C5.18967 13.9591 4.76561 14.562 4.76561 15.2734C4.76561 16.0837 5.31943 16.7608 6.0665 16.9634C5.9849 17.1659 5.93748 17.3857 5.93748 17.6171C5.93748 18.5864 6.72599 19.3749 7.69528 19.3749C8.66458 19.3749 9.45309 18.5864 9.45309 17.6171C9.45309 17.4107 9.41082 17.2154 9.34516 17.0312H14.2485C14.1828 17.2154 14.1406 17.4107 14.1406 17.6171C14.1406 18.5864 14.9291 19.3749 15.8984 19.3749C16.8677 19.3749 17.6562 18.5864 17.6562 17.6171C17.6562 16.6478 16.8677 15.8593 15.8984 15.8593H6.52341C6.20068 15.8593 5.93748 15.5967 5.93748 15.2734C5.93748 14.7276 6.64087 14.6125 6.52341 14.676C6.6406 14.676 7.03677 14.627 18.2993 13.5127C18.5637 13.4864 18.7766 13.2873 18.82 13.0258L19.9919 5.99455C20.0205 5.82459 19.9725 5.65123 19.8614 5.51963ZM8.28122 17.6171C8.28122 17.9404 8.01802 18.2031 7.69528 18.2031C7.37255 18.2031 7.10935 17.9404 7.10935 17.6171C7.10935 17.2938 7.37255 17.0312 7.69528 17.0312C8.01802 17.0312 8.28122 17.2938 8.28122 17.6171ZM15.8984 18.2031C15.5756 18.2031 15.3124 17.9404 15.3124 17.6171C15.3124 17.2938 15.5756 17.0312 15.8984 17.0312C16.2211 17.0312 16.4843 17.2938 16.4843 17.6171C16.4843 17.9404 16.2211 18.2031 15.8984 18.2031ZM9.45309 10.5859C9.45309 10.9098 9.19102 11.1718 8.86715 11.1718C8.54329 11.1718 8.28122 10.9098 8.28122 10.5859V8.24216C8.28122 7.91829 8.54329 7.65622 8.86715 7.65622C9.19102 7.65622 9.45309 7.91829 9.45309 8.24216V10.5859ZM12.9687 10.5859C12.9687 10.9098 12.7066 11.1718 12.3828 11.1718C12.0589 11.1718 11.7968 10.9098 11.7968 10.5859V8.24216C11.7968 7.91829 12.0589 7.65622 12.3828 7.65622C12.7066 7.65622 12.9687 7.91829 12.9687 8.24216V10.5859ZM16.4843 10.5859C16.4843 10.9098 16.2222 11.1718 15.8984 11.1718C15.5745 11.1718 15.3124 10.9098 15.3124 10.5859V8.24216C15.3124 7.91829 15.5745 7.65622 15.8984 7.65622C16.2222 7.65622 16.4843 7.91829 16.4843 8.24216V10.5859Z"
          fill="#1B3048"
          fillOpacity="0.7"
        />
        <path
          d="M17.6562 2.38282C17.6562 2.05895 17.3942 1.79688 17.0703 1.79688H16.1411L16.3127 1.62521C16.5416 1.39634 16.5416 1.02552 16.3127 0.79665C16.0839 0.567783 15.713 0.567783 15.4842 0.79665L14.7266 1.55427L13.9689 0.79665C13.7401 0.567783 13.3693 0.567783 13.1404 0.79665C12.9115 1.02552 12.9115 1.39634 13.1404 1.62521L13.3121 1.79688H12.3828C12.0589 1.79688 11.7969 2.05895 11.7969 2.38282V4.14063H17.6562V2.38282Z"
          fill="#1B3048"
          fillOpacity="0.7"
        />
        <path
          d="M10.625 2.96875H6.52344C6.19957 2.96875 5.9375 3.23082 5.9375 3.55469V4.14062H10.625V2.96875Z"
          fill="#1B3048"
          fillOpacity="0.7"
        />
      </g>
      <defs>
        <clipPath id="clip0_3360_5485">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ];
};
export const MyParcelIcon = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 6.2C10.1114 6.20008 10.2204 6.22756 10.318 6.28L12.6673 7.54867V2H7.33398V7.54867L9.68332 6.282C9.7807 6.22887 9.88972 6.2007 10.0007 6.2Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
      <path
        d="M18.0007 2H14.0007V8.66667C13.9999 8.78221 13.9694 8.89561 13.9122 8.996C13.855 9.09639 13.773 9.1804 13.674 9.24C13.5744 9.29876 13.4613 9.33086 13.3457 9.3332C13.2301 9.33553 13.1159 9.30803 13.014 9.25333L10.0007 7.62667L6.98732 9.25333C6.88561 9.3086 6.77128 9.33643 6.65555 9.33409C6.53983 9.33175 6.42671 9.29933 6.32732 9.24C6.22833 9.1804 6.14631 9.09639 6.08911 8.996C6.03191 8.89561 6.00145 8.78221 6.00065 8.66667V2H2.00065C1.82384 2 1.65427 2.07024 1.52925 2.19526C1.40422 2.32029 1.33398 2.48986 1.33398 2.66667V17.3333C1.33398 17.5101 1.40422 17.6797 1.52925 17.8047C1.65427 17.9298 1.82384 18 2.00065 18H18.0007C18.1775 18 18.347 17.9298 18.4721 17.8047C18.5971 17.6797 18.6673 17.5101 18.6673 17.3333V2.66667C18.6673 2.48986 18.5971 2.32029 18.4721 2.19526C18.347 2.07024 18.1775 2 18.0007 2ZM4.66732 11.3333H7.33398C7.5108 11.3333 7.68036 11.4036 7.80539 11.5286C7.93041 11.6536 8.00065 11.8232 8.00065 12C8.00065 12.1768 7.93041 12.3464 7.80539 12.4714C7.68036 12.5964 7.5108 12.6667 7.33398 12.6667H4.66732C4.49051 12.6667 4.32094 12.5964 4.19591 12.4714C4.07089 12.3464 4.00065 12.1768 4.00065 12C4.00065 11.8232 4.07089 11.6536 4.19591 11.5286C4.32094 11.4036 4.49051 11.3333 4.66732 11.3333ZM9.33398 15.3333H4.66732C4.49051 15.3333 4.32094 15.2631 4.19591 15.1381C4.07089 15.013 4.00065 14.8435 4.00065 14.6667C4.00065 14.4899 4.07089 14.3203 4.19591 14.1953C4.32094 14.0702 4.49051 14 4.66732 14H9.33398C9.5108 14 9.68036 14.0702 9.80539 14.1953C9.93041 14.3203 10.0007 14.4899 10.0007 14.6667C10.0007 14.8435 9.93041 15.013 9.80539 15.1381C9.68036 15.2631 9.5108 15.3333 9.33398 15.3333Z"
        fill="#1B3048"
        fillOpacity="0.7"
      />
    </svg>,
  ];
};

export const Billing = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
        fill={color}
      />
    </svg>,
  ];
};

export const RTL = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z"
        fill={color}
      ></path>
    </svg>,
  ];
};

export const Signin = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
        fill={color}
      ></path>
    </svg>,
  ];
};

// export const Signup = (color) => {
//     return [
//         <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="14"
//             height="14"
//             viewBox="0 0 14 14"
//             key={0}
//         >
//             <path
//                 d="M0,2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2V8a2,2,0,0,1-2,2H2A2,2,0,0,1,0,8Z"
//                 transform="translate(4 4)"
//                 fill={color}
//             />
//             <path
//                 d="M2,0A2,2,0,0,0,0,2V8a2,2,0,0,0,2,2V4A2,2,0,0,1,4,2h6A2,2,0,0,0,8,0Z"
//                 fill={color}
//             />
//         </svg>,
//     ];
// }
//
// const clockicon = [
//     <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         key={0}
//     >
//         <path
//             fillRule="evenodd"
//             clipRule="evenodd"
//             d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6V10C9 10.2652 9.10536 10.5196 9.29289 10.7071L12.1213 13.5355C12.5118 13.9261 13.145 13.9261 13.5355 13.5355C13.9261 13.145 13.9261 12.5118 13.5355 12.1213L11 9.58579V6Z"
//             fill="#111827"
//         ></path>
//     </svg>,
// ];
//
// const bell = [
//     <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         key={0}
//     >
//         <path
//             d="M10 2C6.68632 2 4.00003 4.68629 4.00003 8V11.5858L3.29292 12.2929C3.00692 12.5789 2.92137 13.009 3.07615 13.3827C3.23093 13.7564 3.59557 14 4.00003 14H16C16.4045 14 16.7691 13.7564 16.9239 13.3827C17.0787 13.009 16.9931 12.5789 16.7071 12.2929L16 11.5858V8C16 4.68629 13.3137 2 10 2Z"
//             fill="#111827"
//         ></path>
//         <path
//             d="M10 18C8.34315 18 7 16.6569 7 15H13C13 16.6569 11.6569 18 10 18Z"
//             fill="#111827"
//         ></path>
//     </svg>,
// ];
//
// const wifi = [
//     <svg
//         width="20"
//         height="20"
//         viewBox="0 0 107 107"
//         version="1.1"
//         xmlns="http://www.w3.org/2000/svg"
//         key={0}
//     >
//         <g
//             id="Page-1"
//             stroke="none"
//             stroke-width="1"
//             fill="none"
//             fillRule="evenodd"
//         >
//             <g id="logo-spotify" fill="#2EBD59" fillRule="nonzero">
//                 <path
//                     d="M53.5,0 C23.9517912,0 0,23.9517912 0,53.5 C0,83.0482088 23.9517912,107 53.5,107 C83.0482088,107 107,83.0482088 107,53.5 C107,23.9554418 83.0482088,0.00365063118 53.5,0 Z M78.0358922,77.1597407 C77.0757762,78.7368134 75.0204708,79.2296486 73.4506994,78.2695326 C60.8888775,70.5922552 45.0743432,68.8582054 26.4524736,73.1111907 C24.656363,73.523712 22.8675537,72.3993176 22.458683,70.6032071 C22.0461617,68.8070966 23.1669055,67.0182873 24.9666667,66.6094166 C45.3444899,61.9548618 62.8273627,63.9590583 76.9297509,72.5745479 C78.4995223,73.5419652 78.9996588,75.5899693 78.0358922,77.1597407 L78.0358922,77.1597407 Z M84.5814739,62.5973729 C83.373115,64.5614125 80.8030706,65.1747185 78.8426817,63.9700102 C64.4664961,55.1318321 42.5408052,52.5727397 25.5325145,57.7347322 C23.3275333,58.4027977 20.9984306,57.1579324 20.3267144,54.9566018 C19.6622996,52.7516206 20.9071648,50.4261685 23.1084954,49.7544524 C42.5371546,43.858683 66.6933811,46.7134766 83.2051859,56.8622313 C85.1692255,58.0705902 85.7898328,60.636984 84.5814739,62.5973729 Z M85.1436711,47.4253497 C67.8980894,37.1853292 39.4523712,36.2434664 22.9880246,41.2375299 C20.3449676,42.0406687 17.5485841,40.5475606 16.7490959,37.9045036 C15.9496076,35.2614466 17.4390652,32.4650631 20.0857728,31.6619243 C38.9850904,25.9267827 70.3987718,27.0329239 90.2509041,38.8171614 C92.627465,40.2299556 93.4087001,43.3001365 91.9995565,45.6730467 C90.5940635,48.0532583 87.5165814,48.838144 85.1436711,47.4253497 Z"
//                     id="Shape"
//                 ></path>
//             </g>
//         </g>
//     </svg>,
// ];

export const Credit = (color) => {
  return [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fill="#1890FF"
        d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
      ></path>
      <path
        fill="#1890FF"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
      ></path>
    </svg>,
  ];
};

export const Upload = (color) => {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5089_9998)">
        <path d="M38.1901 17.3569C36.9045 14.9586 35.0372 12.92 32.7446 11.4223C30.1071 9.69963 27.0416 8.78906 23.8789 8.78906C16.0164 8.78906 9.35326 14.3932 7.9277 22.0039C3.39699 22.8439 0 26.8253 0 31.5464C0 36.8988 4.35448 41.2533 9.70688 41.2533H23.5352V28.9658L20.4315 32.0694C19.8593 32.6412 18.932 32.6412 18.3598 32.0694C17.7876 31.4972 17.7876 30.5698 18.3598 29.9976L23.9643 24.3935C24.5361 23.8213 25.4635 23.8213 26.0357 24.3935L31.6402 29.9976C32.2124 30.5698 32.2124 31.4972 31.6402 32.0694C31.3541 32.3555 30.9792 32.4986 30.6046 32.4986C30.2296 32.4986 29.8546 32.3555 29.5685 32.0694L26.4648 28.9658V41.2533H38.0512C44.64 41.2533 50 35.8932 50 29.3045C50 22.7623 44.7151 17.4313 38.1901 17.3569Z" fill="#606F7F" />
      </g>
      <defs>
        <clipPath id="clip0_5089_9998">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

// const setting = [
//     <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         key={0}
//     >
//         <path
//             fillRule="evenodd"
//             clipRule="evenodd"
//             d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
//             fill="#111827"
//         ></path>
//     </svg>,
// ];

// const profile = [
//     <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         key={0}
//     >
//         <path
//             fillRule="evenodd"
//             clipRule="evenodd"
//             d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
//             fill="#111827"
//         ></path>
//     </svg>,
// ];

export const Logout = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 384.971 384.971"
      xmlSpace="preserve"
    >
      <g>
        <g id="Sign_Out">
          <path
            d="M180.455,360.91H24.061V24.061h156.394c6.641,0,12.03-5.39,12.03-12.03s-5.39-12.03-12.03-12.03H12.03
            C5.39,0.001,0,5.39,0,12.031V372.94c0,6.641,5.39,12.03,12.03,12.03h168.424c6.641,0,12.03-5.39,12.03-12.03
            C192.485,366.299,187.095,360.91,180.455,360.91z"
            fill={"#111827"}
          />
          <path
            d="M381.481,184.088l-83.009-84.2c-4.704-4.752-12.319-4.74-17.011,0c-4.704,4.74-4.704,12.439,0,17.179l62.558,63.46H96.279
            c-6.641,0-12.03,5.438-12.03,12.151c0,6.713,5.39,12.151,12.03,12.151h247.74l-62.558,63.46c-4.704,4.752-4.704,12.439,0,17.179
            c4.704,4.752,12.319,4.752,17.011,0l82.997-84.2C386.113,196.588,386.161,188.756,381.481,184.088z"
            fill={"#111827"}
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

// const logsetting = [
//     <svg
//         width="20"
//         height="20"
//         viewBox="0 0 20 20"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         key={0}
//     >
//         <path
//             fillRule="evenodd"
//             clipRule="evenodd"
//             d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
//             fill="#111827"
//         ></path>
//     </svg>,
// ];

export const Toggler = (color) => {
  return [
    <svg
      width="20"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      key={0}
    >
      <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
    </svg>,
  ];
};
